import { LOCALES } from "../constants";

const sv = {
  [LOCALES.SV]: {
    //All page
    "Página não encontrada": "Sidan hittades inte",
    //LOGIN PAGE
  "login.Login": "Logga in",
  "login.Informe seu e-mail": "Ange din e-post",
  "login.E-mail inválido. Por favor, verifique":
    "Ogiltig e-postadress. Vänligen kontrollera det",
  "login.Senha": "Lösenord",
  "login.Sua senha deve possuir no mínimo 6 caracteres":
    "Ditt lösenord måste innehålla minst 6 tecken",
  "login.Esqueci minha senha": "Glömt mitt lösenord",
  "login.ENTRAR": "LOGGA IN",
  "login.CRIAR CONTA": "SKAPA KONTO",
  "login.Não foi possÍvel fazer o login. Verifique seus dados e tente novamente":
    "Kan inte logga in. Vänligen kontrollera dina referenser och försök igen",
  "login.A PLATAFORMA IOK MUDOU!": "IOK-PLATTFORMEN HAR FÖRÄNDRATS!",
  "login.Não exibir este aviso novamente": "Visa inte detta meddelande igen",
  "login.Se você já possui um cadastro na antiga plataforma, ": "Om du redan har ett konto på den tidigare plattformen, ",
  "login.clique aqui": "Klicka här",
  "login. para": " för att ",
  "login.migrar": "migrera ",
  "login.seus dados e aproveitar toda a experiência IOK.": "Dina data och njut av hela IOK-upplevelsen.",
  "login.Sua conta não foi ativada. Por gentileza, verifique seu e-mail para realizar a ativação": "Ditt konto har inte aktiverats. Vänligen kontrollera din e-post för att slutföra aktiveringsprocessen.",
  "login.PLATAFORMA EM MANUTENÇÃO": "PLATTFORMEN GENOMGÅR UNDERHÅLL",
  "login.ESTAMOS PREPARANDO A NOVA PLATAFORMA IOK E EM BREVE ELA ESTARÁ PRONTA!": "VI FÖRBEREDER DEN NYA IOK-PLATTFORMEN, OCH DEN KOMMER SNART ATT VARA KLAR!",
  "login.Migrar Conta": "Migrera konto",
  "login.Se você já possui um cadastro na antiga plataforma, clique aqui em Migrar Conta para migrar seus dados e aproveitar toda a experiência IOK": "Om du redan har ett konto på den tidigare plattformen klickar du på Migrera konto för att migrera dina data och njuta av hela IOK-upplevelsen.",
  "login.Política de privacidade": "Integritetspolicy",
  "login.ENTENDI": "JAG FÖRSTÅR",
  "login.Para melhorar a sua experiência na plataforma e oferecer serviços personalizados, utilizamos cookies.": "För att förbättra din upplevelse på plattformen och tillhandahålla personliga tjänster använder vi cookies.",
  "login.Ao utilizar a Plataforma IOK, você automaticamente concorda com seu uso.": "Genom att använda IOK-plattformen samtycker du automatiskt till användningen av cookies.",
  "login.Senha incorreta! Duas tentativas restantes antes de ter o acesso à conta bloqueado.": "Felaktigt lösenord! Du har två försök kvar innan ditt konto är låst.",
  "login.Senha incorreta! Uma tentativa restantes antes de ter o acesso à conta bloqueado.": "Felaktigt lösenord! Du har ett försök kvar innan ditt konto är låst.",
  "login.Acesso bloqueado! Siga as instruções de recuperação de conta.": "Tillgång låst! Följ kontoåterställningsinstruktionerna.",

    // REGISTER
  "DISTRIBUIDOR": "Distributör: Jag är en Prática-utrustningsdistributör.",
  "REDE": "Jag är ägare till en kedja.",
  "DONO": "Jag äger mitt eget företag / jag är en del av en kedja.",
  "register.Informe seu e-mail cadastrado na plataforma IOK anterior": "Ange e-postadressen registrerad på den tidigare IOK-plattformen",
  "register.E-mail inválido. Por favor, verifique": "Ogiltig e-postadress. Vänligen kontrollera det",
  "register.BUSCAR DADOS": "HÄMTA DATA",
  "register.Nome da organização": "Organisationsnamn",
  "register.Informe o nome de sua organização": "Ange ditt organisationsnamn",
  "register.O campo nome da organização é obrigatório": "Organisationens namnfält krävs",
  "register.Este nome já existe. Por favor, escolha outro": "Detta namn finns redan. Välj en annan",
  "register.RECUPERAR CONTA": "ÅTERSTÄLL KONTO",
  "register.O ADMINISTRADOR DA ORGANIZAÇÃO RECEBERÁ UM E-MAIL PARA ATIVAR SUA CONTA DE USUÁRIO. POR GENTILIZA, AGUARDE": "ORGANISATIONSADMINISTRATÖREN KOMMER ATT FÅ ETT E-POSTMEDDELANDE FÖR ATT AKTIVERA DITT ANVÄNDARKONTO. VÄNTA.",
  "register.E-mail não encontrado": "E-postadressen hittades inte",
  "register.Digite seu e-mail da plataforma IOK antiga": "Ange din e-post från den tidigare IOK-plattformen",
  "register.Não foi possível recuperar sua conta. Verifique seus dados e tente novamente": "Kan inte återställa ditt konto. Vänligen kontrollera din information och försök igen",
  "register.Não foi possível recuperar seus dados. Verifique e tente novamente": "Kan inte hämta dina data. Vänligen kontrollera din information och försök igen",
  "register.PROSSEGUIR": "FORTSÄTT",
  "register.VOCÊ ESTÁ SOLICITANDO ACESSO PARA A ORGANIZAÇÃO:": "DU BEGÄR ÅTKOMST TILL ORGANISATIONEN:",
  "register.COM O ADMINISTRADOR:": " MED ADMINISTRATÖREN:",
  "register.E-mail já cadastrado na plataforma. Informe um novo e-mail ou acesse a plataforma com o e-mail já cadastrado": "Detta e-postmeddelande är redan registrerat på plattformen. Ange ett annat e-postmeddelande eller logga in med den befintliga",
  "register.Empresa já cadastrada na plataforma. Por favor, informe o nome de uma nova empresa": "Detta företag är redan registrerat på plattformen. Vänligen ange ett annat företagsnamn",
  "register.VOCÊ NÃO RECONHECEU O USUÁRIO {userName} COMO PARTE DA SUA ORGANIZAÇÃO E POR ISSO A CONTA DELE FOI DELETADA.": "DU KÄNDE INTE IGEN ANVÄNDAREN {userName} SOM EN DEL AV DIN ORGANISATION, SÅ KONTOT HAR TAGITS BORT.",
  "register.NÂO FOI POSSÍVEL DELETAR O USÁRIO {userName}. POR GENTILEZA, TENTE NOVAMENTE MAIS TARDE.": "DET GICK INTE ATT TA BORT ANVÄNDAREN {userName}. FÖRSÖK IGEN SENARE.",
  "register.CONFIRMAR": "BEKRÄFTA",
  "register.Não foi possível fazer o cadastro. Verifique seus dados e tente novamente":
    "Kan inte slutföra registreringen. Vänligen kontrollera din information och försök igen",
  "register.VOCÊ RECEBERÁ UM E-MAIL PARA CONCLUIR SEU CADASTRO E ATIVAR SUA CONTA DE ADMINISTRADOR":
    "DU FÅR ETT E-POSTMEDDELANDE FÖR ATT SLUTFÖRA DIN REGISTRERING OCH AKTIVERA DITT ADMINISTRATÖRSKONTO",
  "register.Nome": "Namn",
      "register.Informe seu nome": "Ange ditt namn",
    "register.O campo nome é obrigatório": "Namnfältet krävs",
    "register.E-mail": "E-post",
    "register.Informe seu e-mail": "Ange din e-post",
    "register.E-mail inválido. Por favor, verifique novamente":
      "Ogiltig e-postadress. Vänligen kontrollera det igen",
    "register.Telefone": "Telefon",
    "register.Informe seu telefone": "Ange ditt telefonnummer",
    "register.Crie sua senha": "Skapa ditt lösenord",
    "register.Informe sua senha": "Ange ditt lösenord",
    "register.O campo senha deve conter no mínimo 6 caracteres":
      "Lösenordet måste innehålla minst 6 tecken",
    "register.Confirme sua senha": "Bekräfta ditt lösenord",
    "register.As senhas devem ser iguais": "Lösenord måste matcha",
    "register.CRIAR CONTA": "SKAPA KONTO",
    "register.CONTA ATIVADA COM SUCESSO": "KONTO AKTIVERAT FRAMGÅNGSRIKT",
    "register.ACESSAR": "ACCESS ACCESS",
    "register.NÃO FOI POSSÍVEL ATIVAR SUA CONTA":
      "KAN INTE AKTIVERA DITT KONTO",
    "register.Digite seu telefone": "Ange ditt telefonnummer",
    "register.AGUARDE ENQUANTO TRANSFERIMOS SEUS DADOS. ESTE PROCESSO DEVE LEVAR ALGUNS MINUTOS. CASO VOCÊ POSSUA UMA GRANDE QUANTIDADE DE DADOS, A TRANSFERÊNCIA PODE LEVAR ATÉ UMA HORA.": "VÄNTA MEDAN VI ÖVERFÖR DINA UPPGIFTER. DENNA PROCESS BÖR TA NÅGRA MINUTER. OM DU HAR EN STOR MÄNGD DATA KAN ÖVERFÖRINGEN TA UPP TILL EN TIMME.",
    "register.DADOS TRANSFERIDOS COM SUCESSO! CLIQUE NO BOTÃO ABAIXO PARA ACESSAR A PLATAFORMA.": "DATA ÖVERFÖRS FRAMGÅNGSRIKT! KLICKA PÅ KNAPPEN NEDAN FÖR ATT KOMMA ÅT PLATTFORMEN.",
    "register.EMAIL INVÁLIDO. POR GENTILEZA, VERIFIQUE SE SUA CONTA JÁ FOI ATIVADA.": "OGILTIG E-POST. KONTROLLERA OM DITT KONTO REDAN HAR AKTIVERATS.",
    "register.Ainda não tenho uma organização. Criar": "Jag har inte en organisation än. Skapa en",
    "register.Informe o ID da organização": "Ange organisationen ID",
    "register.O campo com ID é obrigatório": "Organisationens ID-fält krävs",
    "register.O ADMINISTRADOR DA ORGANIZAÇÃO RECEBERÁ UM E-MAIL PARA ATIVAR SUA CONTA. POR GENTILIZA, AGUARDE": "ORGANISATIONSADMINISTRATÖREN KOMMER ATT FÅ ETT E-POSTMEDDELANDE FÖR ATT AKTIVERA DITT KONTO. VÄNTA.",
    "register.A nova plataforma IOK agora está dividida em organizações e possui diferentes tipos de conta, que ajudam a organizar melhor as grandes corporações, empresas e redes.": "Den nya IOK-plattformen är nu organiserad i organisationer och erbjuder olika kontotyper för att bättre stödja företag, företag och kedjor.",
    "register.O administrador da minha organização já realizou a migração da conta e temos um ID. Desejo migrar meus dados de usuário.": "Min organisations administratör har redan migrerat kontot och vi har ett ID. Jag vill migrera mina användardata.",
    "register.Desejo migrar a conta da minha organização e me tornar o administrador.": "Jag vill migrera min organisations konto och bli administratör.",
    "register.Conta da organização já migrada": "Organisationskonto redan migrerat",
    "register.Migrar conta da organização": "Migrera organisationskonto",
    "register.A nova plataforma IOK agora conta com novas formas de acesso - que são referentes ao tipo de organização em que você atua. O responsável pela sua organização deve migrar a conta principal da empresa, se tornando o administrador, enquanto o restante dos funcionários devem se vincular a ela pelo ID fornecido.": "Den nya IOK-plattformen erbjuder nu nya åtkomstmetoder baserat på vilken typ av organisation du tillhör. Den person som ansvarar för din organisation måste migrera företagets huvudkonto och bli administratör, medan de återstående anställda ska ansluta sig till organisationen med hjälp av det angivna ID.",
    "register.ID informado não corresponde a nenhuma companhia. Verifique e tente novamente": "Den tillhandahållna ID matchar inte något företag. Vänligen kontrollera det och försök igen.",
    "register.VOCÊ POSSUI MUITOS MENUS, NÃO CONSEGUIMOS REALIZAR A IMPORTAÇÃO AUTOMÁTICA. SUA CONTA SERÁ ATIVADA, PORÉM OS MENUS PRECISARÃO SER MIGRADOS MANUALMENTE.": "DU HAR FÖR MÅNGA MENYER. VI KUNDE INTE SLUTFÖRA DEN AUTOMATISKA IMPORTEN. DITT KONTO AKTIVERAS, MEN MENYERNA MÅSTE MIGRERAS MANUELLT.",
    "register.PARA MIGRAR SEUS MENUS, APÓS O LOGIN, CLIQUE NO SEU NOME NO CANTO SUPERIOR DIREITO, CLIQUE EM EDITAR CONTA E DEPOIS EM IMPORTAR MENUS.": "FÖR ATT MIGRERA DINA MENYER, EFTER ATT HA UNDERTECKNAT, KLICKA PÅ DITT NAMN I DET ÖVRE HÖGRA HÖRNET, KLICKA SEDAN PÅ REDIGERA KONTO OCH VÄLJ IMPORTMENYER.",
    "register.Atenção:": "Uppmärksamhet:",
        "register.apenas uma pessoa da organização pode criar a conta e, depois de ativá-la, convidar os demais usuários da empresa para acessá-la.": "Endast en person i organisationen kan skapa kontot och, efter att ha aktiverat det, bjud in de andra företagsanvändarna att komma åt det.",
    "register.TOKEN DESENVOLVEDOR CANCELADO": "UTVECKLARE TOKEN AVBRYTS",
    "register.Sua senha deve estar entre 8 e 20 caracteres, ter uma letra maiúscula, uma minúscula, um número e um caractere especial": "Ditt lösenord måste vara mellan 8 och 20 tecken långa och inkludera ett övre bokstav, ett bokstäver, ett nummer och en speciell karaktär.",

    //HOME
    "home.Menus disponíveis na plataforma": "Menyer tillgängliga på plattformen",
    "home.Criados na plataforma": "Skapad på plattformen",
    "home.Recebidos dos fornos": "Fått från Ovens",
    "home.Equipamentos vinculados": "Länkat utrustning",
    "home.Total de receitas cadastradas": "Totalregistrerade recept",
    "home.Receitas": "Recept",
    "home.Receitas em menus": "Recept i Menus",
    "home.Em menus": "I Menus",
    "home.Receitas salvas no Cookbook": "Recept sparade i Cookbook",
    "home.No Cookbook": "I Cookbook",
    "home.Atualizações": "Uppdateringar",
    "home.Copa": "Copa",
    "home.Rocket": "Rocket",
    "home.Single Mag": "Single Mag",
    "home.Versão instalada": "Installerad version",
    "home.Versão disponível": "Tillgänglig version",
    "home.Usuários cadastrados": "Registrerade användare",
    "home.Aceitação pendente": "I väntan på godkännande",
    "home.Atualizado": "Upp till datum",
    "home.OLÁ": "HEJ",
    "home.É muito bom ter você aqui!": "Det är bra att ha dig här!",
    "home.Com a Plataforma IOK é possível administrar seus fornos de onde estiver, criar e gerenciar receitas e menus, fazer backups, analisar os dados de seus equipamentos e muito mais!": "Med IOK-plattformen kan du hantera dina ugnar var som helst, skapa och hantera recept och menyer, göra säkerhetskopior, analysera dina utrustningsdata och mycket mer!",
    "home.Conheça a plataforma": "Upptäck plattformen",
    "home.Taxa de erro por modelo": "Fel Rate av modell",
    "home.Erro": "Fel",
      "home.QUEREMOS SABER SUA OPINIÃO SOBRE": "VI VILL HÖRA DIN ÅSIKT OM",
  "home.Valorizamos muito seu ponto de vista e, por isso, este formulário de pesquisa de satisfação sobre a Plataforma {model} foi criado!": "Vi värdesätter din åsikt, vilket är anledningen till att vi skapade denna kundnöjdhetsundersökning om {model}-plattformen!",
  "home.Valorizamos muito seu ponto de vista e, por isso, este formulário de pesquisa de satisfação sobre a linha {model} foi criado!": "Vi värdesätter din åsikt, vilket är anledningen till att vi skapade denna kundnöjdhetsundersökning om {model}-produktlinjen!",
  "home.Suas respostas nos ajudarão a aprimorar nossos serviços, garantindo que continuemos a oferecer a você a melhor experiência possível.": "Dina svar hjälper oss att förbättra våra tjänster, så att vi fortsätter att ge dig bästa möjliga upplevelse.",
  "home.Reserve uns minutinhos de seu dia e participe!": "Ta några minuter av din dag och delta!",
  "home.Responder a pesquisa": "Ta undersökningen",
  "home.Modelos em evidência": "Utvalda modeller",
  "home.Modelos": "Modeller",
  "home.Total de equipamentos vinculados": "Totalt antal länkade enheter",
  "home.Total de equipamentos online": "Total online-utrustning",
  "home.Equipamentos online": "Onlineutrustning",
  "home.Países com Prática": "Länder med Prática",
  "home.Países": "Länder",
  "home.Aguarde enquanto carregamos os dados": "Vänta medan vi laddar data",
  "home.Quase lá! Aguarde um pouco mais": "Nästan där! Vänta lite längre",
  "home.Vendas por Equipamento": "Försäljning av utrustning",
  "home.Total de equipamentos vendidos": "Total utrustning såld",
  "home.Equipamentos vendidos": "Utrustning såld",
  "home.Clique para atualizar o software": "Klicka för att uppdatera programvaran",
  "home.Aceitação de software pendente": "I väntan på mjukvaruacceptans",
  "home.Software atualizado": "Programvara upp till datum",
  "home.NENHUM EQUIPAMENTO VINCULADO": "INGEN LÄNKAD UTRUSTNING",
  "home.FORNOS LIGADOS": "OVENS DRIVS PÅ",
  "home.Enviando dados": "Skicka data",
  "home.Com conectividade IOK": "Med IOK Connectivity",
  "home.Sem envio de dados": "Inte skicka data",
  "home.Sem conectividade IOK": "Utan IOK Connectivity",
  "home.Criados na Plataforma": "Skapad på plattformen",
  "home.Apenas no Cookbook": "Endast i Cookbook",
  "home.Usuários na companhia": "Företagsanvändare",
  "home.Inativos": "Inaktiv",
  "home.Online": "Online Online Online",
    "home.Atualizações de equipamentos": "Utrustningsuppdateringar",
  "home.Modelos de equipamentos": "Utrustningsmodeller",
  "home.Atualizados": "Upp till datum",
  "home.Aguardando Aceite": "Väntar Acceptance",
  "home.Desatualizados": "Från Date",

  //MAIN
  "main.HOME": "HEMSIDAN",
  "main.COOKBOOK": "COOKBOOK",
  "main.MEUS MENUS": "MIN MENY",
  "main.EQUIPAMENTOS": "UTRUSTNING",
  "main.USUÁRIOS": "ANVÄNDARE",
  "main.ATENDIMENTOS": "SERVICEFÖRFRÅGNINGAR",
  "main.Idioma": "Språkspråk",
  "main.Editar conta": "Redigera konto",
  "main.Configurações": "Inställningar",
  "main.Sair": "Logga ut",
  "main.Configurações salvas com sucesso!": "Inställningar sparade framgångsrikt!",
  "main.SALVAR": "SPARA",
  "main.CONFIGURAÇÕES": "INSTÄLLNINGAR",
  "main.Tema dark": "Mörk tema",
  "main.Notificações": "Meddelanden",
  "main.Informações para as receitas": "Receptinställningar",
  "main.Peso:": "Vikt:",
  "main.Gramas": "Gram",
  "main.Oz": "Oz",
  "main.Temperatura:": "Temperatur:",
  "main.Fahrenheit (°F)": "Fahrenheit (°F)",
  "main.Conta editada com sucesso!": "Konto uppdaterat framgångsrikt!",
  "main.EDITAR CONTA": "REDIGERA KONTO",
  "main.Nome": "Namn",
  "main.Preencha com o seu nome": "Ange ditt namn",
  "main.Telefone": "Telefon",
  "main.Preencha com o seu telefone": "Ange ditt telefonnummer",
  "main.E-mail": "E-post",
  "main.Preencha com o seu e-mail": "Ange din e-post",
  "main.Alterar Senha": "Ändra lösenord",
  "main.ALTERAR SENHA": "ÄNDRA LÖSENORD",
  "main.Senha atual": "Nuvarande lösenord",
    "main.Nova senha": "Nyt lösenord",
  "main.Confirmar nova senha": "Bekräfta nytt lösenord",
  "main.Informe sua senha atual": "Ange ditt nuvarande lösenord",
  "main.O campo senha deve conter no mínimo 6 caracteres":
    "Lösenordet måste innehålla minst 6 tecken",
  "main.Informe sua nova senha": "Ange ditt nya lösenord",
  "main.Confirme sua nova senha": "Bekräfta ditt nya lösenord",
  "main.Sua nova senha deve conter no mínimo 6 caracteres":
    "Ditt nya lösenord måste innehålla minst 6 tecken",
  "main.INFORME SUA SENHA": "ANGE DITT LÖSENORD",
  "main.Informe sua senha para realizar a alteração de e-mail da plataforma:":
    "Ange ditt lösenord för att ändra din plattform e-postadress:",
  "main.CONFIRMAR": "BEKRÄFTA",
  "main.Existem campos que não foram preenchidos corretamente":
    "Vissa fält har inte fyllts i korrekt",
  "main.Informe sua senha para prosseguir com a alteração de e-mail":
    "Ange ditt lösenord för att fortsätta med att ändra din e-postadress",
  "main.Senha alterada com sucesso": "Lösenord förändrats framgångsrikt",
  "main.Informe sua senha atual corretamente": "Ange ditt nuvarande lösenord korrekt",
  "main.As senhas devem ser iguais": "Lösenord måste matcha",
  "main.Nome do novo tipo de usuário": "Ny användartyp namn",
  "main.Dê um nome para o novo tipo de usuário": "Ange ett namn för den nya användartypen",
  "main.Token Desenvolvedor": "Utvecklare Token",
  "main.O Token Desenvolvedor é um código único e intransferível que permite a realização de alterações": "Utvecklaren Token är en unik, icke-överförbar kod som gör det möjligt att ändra utvecklingsnivån direkt till plattformskoden genom externa API. Dessa API möjliggör plattform anpassning för att bättre möta ditt företags behov.",
  "main.É recomendado que estas alterações sejam realizadas por um profissional da área de tecnologia": "Det rekommenderas att dessa förändringar genomförs av en teknisk professionell.",
  "main.Para acessar o token, informe sua senha": "Ange ditt lösenord för att komma åt token",
  "main.Copie e cole o token na autenticação de todas as requisições.": "Kopiera och klistra in token i autentiseringen av alla förfrågningar.",
  "main.Seu Token": "Din token",
  "main.Token copiado com sucesso!": "Token kopierade framgångsrikt!",
  "main.Você deseja cancelar o preenchimento das informações?": "Vill du avbryta fyllningen i informationen?",
  "main.Rever tutoriais": "Granska Tutorials",
  "main.Tutoriais resetados com sucesso!": "Tutorials återställs framgångsrikt!",
  "main.review.tutorials": "Vill du granska IOK Platform tutorials?",
  "main.Procurar": "Sök efter Sök",
    "main.review.manual": "Du kan också spara den till din dator.",
  "main.review.download": "Öppen manual",

  //MEUS MENUS
  "menus.Procurar menu": "Sök menyn eller användaren",
  "menus.Procurar menu excluído": "Sök borttagen meny",
  "menus.Menus": "Menyer",
  "menus.Lixeira": "Papperskorg",
  "menus.CRIAR MENU": "SKAPA MENY",
  "menus.IMPORTAR MENU": "IMPORTERA MENYN",
  "menus.Os arquivos serão mantidos na lixeira por 30 dias a contar de sua data de exclusão. Após este período, eles serão excluídos definitivamente.":
    "Filer kommer att förbli i papperskorgen i 30 dagar från det datum de raderades. Efter denna period kommer de att raderas permanent.",
  "menus.VOLTAR": "TILLBAKA",
  "menus.Compatível com: ": "Kompatibel med: ",
  "menus.Última atualização: ": "Senast uppdaterad: ",
  "menus.EXPORTAR MENU": "EXPORTMENY",
  "menus.EDITAR MENU": "REDIGERA MENYN",
  "menus.Equipamentos associados": "Associerad utrustning",
  "menus.Grupos": "Grupper",
  "menus.Procurar grupo": "Sökgrupp",
  "menus.CRIAR GRUPO": "SKAPA GRUPP",
  "menus.receitas": "recept",
  "menus.Nenhum grupo cadastrado": "Inga grupper registrerade",
  "menus.Nenhum menu cadastrado": "Inga menyer registrerade",
  "menus.Nome": "Namn",
  "menus.Modelo": "Modellmodell",
  "menus.Atividade": "Aktivitet",
  "menus.Associação": "Förening",
  "menus.Exportar": "Exportera",
  "menus.Editar": "Redigera",
  "menus.Excluir": "Ta bort",
  "menus.Equips": "Utrustning",
  "menus.Receitas": "Recept",
  "menus.Compatibilidade": "Kompatibilitet",
  "menus.Última atualização": "Senast uppdaterad",
  "menus.Versão": "Version",
  "menus.Origem": "Källa",
  "menus.Excluído por: ": "Tas bort av: ",
  "menus.Restaurar": "Återställ",
  "menus.Existem campos que não foram preenchidos":
    "Vissa nödvändiga fält har inte fyllts i",
  "menus.Menu criado com sucesso!": "Menyn skapas framgångsrikt!",
  "menus.Existem campos com informações inválidas": "Vissa fält innehåller ogiltig information",
      "menus.Existem campos com informações inválidas": "Vissa fält innehåller ogiltig information",
    "menus.SALVAR": "SPARA",
    "menus.CANCELAR": "AVBRYT",
    "menus.Nome do menu": "Menynamn",
    "menus.Informe o nome do menu": "Ange menyn namn",
    "menus.Preencha o nome do menu sem caracteres especiais": "Ange menyn namn utan speciella tecken",
    "menus.Apenas os caracteres @#%&*-+()!\"<>:;\\/?. são permitidos": "Endast tecknen @#%&*-+()!<>:;/? är tillåtna",
    "menus.Selecionar": "Välj Välj",
    "menus.Idioma": "Språkspråk",
    "menus.Temperatura de pré-aquec 1": "Förvärmningstemperatur 1",
    "menus.Informe a temperatura de pré-aquec 1":
      "Ange förvärmningstemperatur 1",
    "menus.Temperatura de pré-aquec 2": "Förvärmningstemperatur 2",
    "menus.Informe a temperatura de pré-aquec 2":
      "Ange förvärmningstemperatur 2",
    "menus.Tempo para estabilização": "Stabiliseringstid",
    "menus.Informe o tempo para estabilização":
      "Ange stabiliseringstiden",
    "menus.Desativar pré-aquec 2": "Inaktivera förvärmning 2",
    "menus.Configurações de data e hora": "Datum och tidsinställningar",
    "menus.Data:": "Datum:",
    "menus.DD/MM/AAAA": "DD/MM/YYY",
    "menus.Hora:": "Tid:",
    "menus.24h": "24 timmar",
    "menus.AM/PM": "AM/PM",
    "menus.EUR: DD/MM/AAAA": "EUR: DD/MM/YYYY",
    "menus.USA: MM/DD/AAAA": "USA: MM/DD/YYYY",
    "menus.ISO: AAAA/MM/DD": "ISO: YYYY/MM/DD",
    "menus.Seleção de acessos para habilitar":
      "Välj funktioner för att aktivera",
    "menus.Modo manual": "Manuellt läge",
    "menus.Habilitado": "Aktiverad",
    "menus.Desabilitado": "Inaktiverad",
    "menus.Favoritos": "Favoriter",
    "menus.Aquecer/Dourar": "Värme/brun",
    "menus.Repetir receita": "Upprepa receptet",
    "menus.Configurações gerais do menu": "Allmän menyinställningar",
    "menus.Temperatura:": "Temperatur:",
    "menus.Fahrenheit (°F)": "Fahrenheit (°F)",
    "menus.Gramas": "Gram",
    "menus.Oz": "Oz",
    "menus.Tema:": "Tema:",
        "menus.Dark": "Mörk",
    "menus.Light": "Ljus ljus",
    "menus.Introdução:": "Introduktion:",
    "menus.Ativada": "Aktiverad",
    "menus.Desativada": "Inaktiverad",
    "menus.Menu deletado com sucesso!": "Menyn raderas framgångsrikt!",
    "menus.Não foi possivel deletar o menu": "Kan inte ta bort menyn",
    "menus.Sim": "Ja",
    "menus.Não": "Nej",
    "menus.Excluir definitivamente": "Ta bort permanent",
    "menus.SALVAR NO DISPOSITIVO": "SPARA TILL ENHET",
    "menus.EXPORTAR": "EXPORTERA",
    "menus.Selecione os modelos e versões dos equipamentos que receberão o menu.":
      "Välj utrustningsmodeller och versioner som får menyn.",
    "menus.Forno": "Ugn",
    "menus.Fundo verde": "Gröna Bakgrund",
    "menus.Fundo preto": "Svart bakgrund",
    "menus.Linux": "Linux",
    "menus.Atenção: antes de transferir o menu de seu pen drive para o equipamento, é necessário descompactar o arquivo, exceto para menus de equipamentos Linux.":
      "Uppmärksamhet: innan du överför menyn från din USB-enhet till utrustningen måste du extrahera filen, förutom menyerna Linux-utrustning.",
    "menus.Selecione os equipamentos para os quais deseja exportar o menu.":
      "Välj den utrustning som du vill exportera menyn.",
    "menus.Nome do equipamento": "Utrustningsnamn",
    "menus.Selecionar todos": "Välj alla",
    "menus.Selecionar todas": "Välj alla",
    "menus.Categoria: ": "Kategori: ",
    "menus.Você deseja excluir o menu?": "Vill du ta bort menyn?",
    "menus.O menu será deletado da plataforma, mas permanecerá no equipamento. Uma cópia de segurança será criada automaticamente e ficará disponível por 30 dias em Meus Menus - Lixeira.":
      "Menyn raderas från plattformen men kommer att finnas kvar på utrustningen. En säkerhetskopia skapas automatiskt och kommer att finnas tillgänglig i 30 dagar under My Menus - Trash.",
    "menus.Você deseja excluir o arquivo definitivamente?":
      "Vill du permanent radera filen?",
    "menus.Esta ação não poderá ser desfeita.":
      "Denna åtgärd kan inte ångras.",
    "menus.Menu editado com sucesso!": "Meny redigerad framgångsrikt!",
    "menus.IMPORTAR": "IMPORTERA IMPORT",
      "menus.VERIFICAÇÃO DE VERSÃO": "VERSIONSKONTROLL",
  "menus.Para conferir a versão da placa de seu equipamento, siga os seguintes passos:":
    "För att kontrollera din utrustnings styrelseversion, följ dessa steg:",
  "menus.No forno, acesse Configurações;": "På ugnen, öppna inställningar;",
  "menus.Insira a senha 456789;": "Ange lösenordet 456789;",
  "menus.Selecione a opção Sistema;": "Välj alternativet System;",
  "menus.Selecione Informações do Fabricante;":
    "Välj Tillverkarinformation;",
  "menus.O modelo de sua placa estará na linha Firmware IHM;":
    "Din brädmodell visas på HMI Firmware-linjen;",
  "menus.1ª geração A": "Första generationen A",
  "menus.Firmware IHM: 12.3.4": "HMI Firmware: 12.3.4",
  "menus.1ª geração B": "Första generationen B",
  "menus.2ª geração/Linux:": "2:a generationen/Linux:",
  "menus.Firmware IHM: L1.2.3": "HMI Firmware: L1.2.3",
  "menus.Selecione o modelo/versão do equipamento do qual deseja importar o menu. Saiba como conferir a versão de seu equipamento":
    "Välj modell/version av den utrustning från vilken du vill importera menyn. Lär dig hur du kontrollerar din utrustning version ",
  "menus.Como verificar a versão da placa":
    "Hur man kontrollerar Board Version",
  "menus.1° Geração": "Första generationen",
  "menus.Menu restaurado com sucesso!": "Menyn återställs framgångsrikt!",
  "menus.Não foi possivel restaurar o menu":
    "Kan inte återställa menyn",
  "menus.RESTAURAR ARQUIVO": "ÅTERSTÄLL FILEN",
  "menus.Você deseja restaurar o arquivo?":
    "Vill du återställa filen?",
  "menus.O arquivo será restaurado como uma nova versão na plataforma, na guia Todos. Para salvá-lo no equipamento, exporte-o.":
    "Filen kommer att återställas som en ny version på plattformen under fliken Alla. För att spara den till utrustningen, exportera den.",
  "menus.EXCLUIR MENU": "TA BORT MENYN",
  "menus.Nenhum equipamento associado": "Ingen associerad utrustning",
  "menus.Nomeie o novo menu": "Namnet på den nya menyn",
  "menus.Nomeie o novo grupo": "Namnet på den nya gruppen",
  "menus.Nome do grupo": "Gruppnamn",
  "menus.Preencha o nome do grupo sem caracteres especiais": "Ange gruppnamnet utan speciella karaktärer",
  "menus.Pré-aquecimento:": "Förvärmning:",
  "menus.Grupo criado com sucesso!": "Grupp skapade framgångsrikt!",
  "menus.SELECIONE UMA IMAGEM": "VÄLJ EN BILD",
  "menus.SELECIONAR": "VÄLJ VÄLJ",
  "menus.Selecionar do dispositivo": "Välj från Device",
  "menus.Selecionar do banco de imagens": "Välj från Image Library",
  "menus.Formato .JPG ou .PNG": "JPG eller .PNG Format",
  "menus.Procurar imagem": "Sök Bild",
  "menus.Pertence ao menu": "Tillhör Menu",
  "menus.Alterar imagem": "Ändra bild",
  "menus.Remover imagem": "Ta bort bild",
  "menus.EDITAR GRUPO": "REDIGERA GRUPP",
      "menus.Nome:": "Namn:",
    "menus.CRIAR RECEITA": "SKAPA RECEPT",
    "menus.SALVAR DO COOKBOOK": "SPARA FRÅN COOKBOOK",
    "menus.Procurar receita do grupo": "Sök Group Recept",
    "menus.Ingrediente principal": "Huvud Ingrediens",
    "menus.Limpar filtros": "Rensa filter",
    "menus.Filtrar": "Filtrera",
    "menus.Mover receitas": "Flytta recept",
    "menus.Excluir receitas": "Radera recept",
    "menus.Editar grupo": "Redigera grupp",
    "menus.Excluir grupo": "Ta bort grupp",
    "menus.aqui": "här här här här",
    "menus.Se o código possuir apenas números e o fundo da tela for verde, pertence à 1ª A, se possuir apenas números e o fundo da tela for preta, pertence à 1ª B e, se começar com as letras L, F ou S, sua placa pertence à 2ª geração/Linux.":
      "Om koden endast innehåller siffror och skärmbakgrunden är grön, hör den till 1: a generationen A. Om den endast innehåller siffror och skärmbakgrunden är svart, hör den till 1st Generation B. Om det börjar med bokstäverna L, F eller S, hör ditt styrelse till 2nd Generation/Linux.",
    "menus.1ª A - Fundo verde": "Första Gen A - Grönt Bakgrund",
    "menus.1ª B - Fundo preto": "Första Gen B - Svart Bakgrund",
    "menus.2ª - Linux": "2nd Gen - Linux",
    "menus.Tivemos um problema. Tente novamente mais tarde.":
      "Vi stötte på ett problem. Försök igen senare.",
    "menus.Grupo editado com sucesso!": "Gruppen redigerade framgångsrikt!",
    "menus.AINDA NÃO HÁ GRUPOS AQUI :(": "DET FINNS INGA GRUPPER HÄR ÄN:(",
    "menus.description.AINDA NÃO HÁ GRUPOS AQUI :(": "Klicka på knappen i det övre högra hörnet för att lägga till grupper.",
    "menus.NENHUM MENU NA LIXEIRA": "INGEN MENY I PAPPERSKORGEN",
    "menus.AINDA NÃO HÁ MENUS AQUI :(": "DET FINNS INGA MENYER HÄR ÄN:(",
    "menus.description.AINDA NÃO HÁ MENUS AQUI :(": "Klicka på en av knapparna i det övre högra hörnet för att lägga till menyer.",
    "menus.Adicionar imagem": "Lägg till bild",
    "menus.Nome da receita": "Receptnamn",
    "menus.Detalhes da receita": "Receptinformation",
    "menus.Programação da receita": "Receptprogrammering",
    "menus.Nomeie sua receita": "Namnge ditt recept",
    "menus.Preencha o nome da receita sem caracteres especiais": "Ange receptnamnet utan speciella tecken",
    "menus.Tipo de prato": "Typ av rätt",
    "menus.SALVAR RECEITAS DO COOKBOOK": "SPARA RECEPT FRÅN KOKBOK",
    "menus.Selecione as receitas que deseja salvar no grupo de seu menu:":
      "Välj de recept du vill spara i menygruppen:",
    "menus.Procurar receita": "Sök Recept",
    "menus.deleteGroupSuccess":
      "{count, plural, one {Gruppen raderades framgångsrikt!} other {Grupper raderade framgångsrikt!}}",
    "menus.deleteGroupError":
      "{count, plural, one {Kan inte ta bort gruppen.} other {Kan inte ta bort grupperna.}}",
    "menus.EXCLUIR GRUPO": "TA BORT GRUPP",
    "menus.confirmDeleteGroupMessage": "{count, plural, one {Vill du permanent ta bort gruppen?} other {Vill du permanent radera grupperna?}}",
    "menus.AINDA NÃO HÁ RECEITAS AQUI :(": "DET FINNS INGA RECEPT HÄR ÄN:(",
    "menus.description.AINDA NÃO HÁ RECEITAS AQUI :(": "Klicka på en av knapparna i det övre högra hörnet för att lägga till recept.",
    "menus.Temp. de entrada": "Ingångstemperatur",
    "menus.Temp. de pré-aquec": "Förvärmningstemperatur",
    "menus.Ingredientes para montagem": "Monteringsingredienser",
    "menus.Instruções operacionais": "Operativa instruktioner",
    "menus.Passo": "Steg Steg",
    "menus.Temp": "Temp",
    "menus.Temp.": "Temp.",
    "menus.Tempo": "Tid",
    "menus.Velocidade do ar": "Lufthastighet",
    "menus.Micro-ondas": "Mikrovågor",
    "menus.Resistência inferior": "Lägre värmeelement",
    "menus.Informações": "Information om information",
    "menus.Digite as informações do passo": "Ange steginformation",
    "menus.desativar": "Inaktivera",
    "menus.Ingredientes": "Ingredienser",
    "menus.Temperatura de entrada": "Inträdestemperatur",
    "menus.Equipamentos compatíveis": "Kompatibel utrustning",
    "menus.SALVAR NO COOKBOOK": "SPARA TILL COOKBOOK",
    "menus.ver localização": "Visa plats",
    "menus.SELECIONE RECEITAS PARA EXCLUIR": "VÄLJ RECEPT FÖR ATT RADERA",
    "menus.Você deseja excluir as receitas selecionadas definitivamente?":
      "Vill du permanent ta bort de valda recepten?",
    "menus.Receitas deletadas com sucesso!": "Recept raderade framgångsrikt!",
    "menus.Informe aqui os ingredientes para montagem":
      "Ange monteringsingredienserna här",
    "menus.Informe aqui as instruções operacionais":
      "Ange driftsanvisningarna här",
    "menus.Adicionar passo": "Lägga till steg",
    "menus.Receita criada com sucesso!": "Recept skapade framgångsrikt!",
    "menus.Ideal para:": "Perfekt för: ",
    "menus.editar detalhes": "Redigera detaljer",
    "menus.excluir": "Ta bort",
    "menus.editar": "redigera",
    "menus.Receita editada com sucesso!": "Recept redigerade framgångsrikt!",
    "menus.Passo deletado com sucesso!": "Steg raderat framgångsrikt!",
    "menus.Não foi possivel deletar o passo":
      "Kan inte ta bort steget",
    "menus.EXCLUIR PASSO": "TA BORT STEG",
      "menus.Você deseja excluir este passo?": "Vill du ta bort detta steg?",
  "menus.Esta ação não poderá ser desfeita. Caso prefira, é possível apenas desativá-lo, mantendo assim sua configuração.":
    "Denna åtgärd kan inte ångras. Om du föredrar kan du helt enkelt inaktivera det samtidigt som du håller konfigurationen.",
  "menus.Peso": "Vikt",
  "menus.Origem da receita": "Receptkälla",
  "menus.Pré-aquecimento": "Förvärmning",
  "menus.Plataforma": "Plattform",
  "menus.Receita salva com sucesso!": "Recept räddade framgångsrikt!",
  "menus.Exportar receitas": "Exportrecept",
  "menus.expandir": "expand expand expand expand expand expand",
  "menus.Temperatura": "Temperatur",
  "menus.Vapor combinado": "Kombiånga",
  "menus.Ar quente": "Varmluft",
  "menus.Sonda": "Givare",
  "menus.Tempo (min)": "Tid (min)",
  "menus.Umidade (%)": "Luftfuktighet (%)",
  "menus.Injeção de vapor": "Ånginjektion",
  "menus.Dumper aberto": "Spjäll öppet",
  "menus.Informe o peso": "Ange vikten",
  "menus.Informe a temperatura de entrada":
    "Ange ingångstemperaturen",
  "menus.Informe os ingredientes para montagem":
    "Ange monteringsingredienserna",
  "menus.Informe as instruções operacionais":
    "Ange driftsanvisningarna",
  "menus.Injeção de vapor (seg)": "Ånginjektion (sek)",
  "menus.Aquecer mais": "Värme mer",
  "menus.Dourar mais": "Brown mer",
  "menus.Aquecer e dourar mais": "Värme och Brown mer",
  "menus.Favoritar receita": "Favoritrecept",
  "menus.Informe o tempo para aquecer mais":
    "Ange tiden för värme mer",
  "menus.Informe o tempo para dourar mais":
    "Ange tiden för Brown More",
  "menus.Informe o tempo para aquecer e dourar mais":
    "Ange tiden för värme och brunn mer",
  "menus.Apenas favoritos": "Favoriter endast",
  "menus.Forno combinado": "Kombiugn",
  "menus.Cocção múltipla": "Multipel matlagning",
  "menus.Receitas Technicook": "Technicook Recept",
  "menus.Editar grupos": "Redigera grupper",
      "menus.Informe a data": "Ange datum",
    "menus.Informe a hora": "Ålder tid",
    "menus.até 300": "upp till 300",
    "menus.Vapor": "Ånga",
    "menus.Turbina": "Fläkt",
    "menus.Criar grupo": "Skapa grupp",
    "menus.MOVER": "FLYTTA",
    "menus.Configurações de data e hora:": "Datum- och tidsinställningar:",
    "menus.Configurações de acessos:": "Åtkomstinställningar:",
    "menus.Modo manual:": "Manuellt läge:",
    "menus.Favoritos:": "Favoriter:",
    "menus.Aquecer/dourar:": "Värm/Bryna:",
    "menus.Repetir receita:": "Upprepa recept:",
    "menus.Configurações gerais do menu:": "Allmänna menyinställningar:",
    "menus.SELECIONE RECEITAS PARA MOVER": "VÄLJ RECEPT ATT FLYTTA",
    "menus.AVANÇAR": "NÄSTA",
    "menus.Selecione ou crie um grupo no mesmo menu para mover as receitas selecionadas ou as mova para outro menu. Note que apenas os menus/grupos compatíveis com as predefinições das receitas serão exibidos.": "Välj eller skapa en grupp i samma meny för att flytta de valda recepten, eller flytta dem till en annan meny. Observera att endast menyer/grupper som är kompatibla med receptens förinställningar kommer att visas.",
    "menus.Mover receitas para o mesmo menu": "Flytta recept till samma meny",
    "menus.Mover receitas para outro menu": "Flytta recept till en annan meny",
    "menus.Selecionar grupo": "Välj grupp",
    "menus.Nenhuma receita foi selecionada": "Inga recept har valts",
    "menus.Passo editado com sucesso!": "Steget har redigerats.",
    "menus.Menu atualizado": "Menyn har uppdaterats",
    "menus.até 260": "upp till 260",
    "menus.Umidade na câmara": "Kammarfuktighet",
    "menus.Passos": "Steg",
    "menus.ativar": "in",
    "menus.Informe a temperatura de pré-aquec": "Ange förvärmningstemperaturen",
    "menus.Movas as receitas selecionadas para outro menu. Note que apenas os menus compatíveis com as predefinições das receitas serão exibidos.":
      "Flytta de valda recepten till en annan meny. Observera att endast menyer som är kompatibla med receptens förinställningar kommer att visas.",
    "menus.Sonda (°C)": "Temperaturgivare (°C)",
    "menus.Turbo Grill": "Turbo Grill",
    "menus.Pré-aquecimento padrão, conforme passo 1": "Standardförvärmning enligt steg 1",
    "menus.salvar": "Spara",
    "menus.até": "upp till",
    "menus.Verificação de receita": "Receptverifiering",
    "menus.Auto import": "Automatisk import",
    "menus.Atualização forçada": "Tvingad uppdatering",
      "menus.Lista de receitas exportada com sucesso!": "Receptlistan har exporterats.",
  "menus.Receita movida com sucesso!": "Receptet har flyttats.",
  "menus.Receitas movidas com sucesso!": "Recepten har flyttats.",
  "menus.+ Menu": "+ Meny",
  "menus.+ Receita": "+ Recept",
  "menus.Selecione o modelo/versão do equipamento": "Välj utrustningens modell/version",
  "menus.Escolha um idioma compatível com o equipamento": "Välj ett språk som är kompatibelt med utrustningen",
  "menus.MENU IMPORTADO COM SUCESSO!": "MENYN HAR IMPORTERATS!",
  "menus.Dourar": "Bryna",
  "menus.Não atribuir a menu": "Tilldela inte till meny",
  "menus.Todos": "Alla",
  "menus.Meus menus": "Mina menyer",
  "menus.Para salvar uma receita, preencha todos os campos": "Fyll i alla fält för att spara receptet",
  "menus.Selecione os grupos de equipamentos para os quais deseja exportar o menu.": "Välj de utrustningsgrupper som du vill exportera menyn till.",
  "menus.Formato inválido. São permitidos apenas os formatos .jpeg e .png": "Ogiltigt format. Endast .jpeg- och .png-format stöds.",
  "menus.Reordenar grupos": "Ordna om grupper",
  "menus.O que deseja fazer?": "Vad vill du göra?",
  "menus.Reordenar receitas": "Ordna om recept",
  "menus.ITENS REORDENADOS COM SUCESSO! PARA APLICAR AS ÄNDRINGAR NO FORNO, EXPORTE O MENU.": "OBJEKTEN HAR ORDNATS OM! EXPORTERA MENYN FÖR ATT TILLÄMPA ÄNDRINGARNA I UGNEN.",
  "menus.ARRASTE OS ITENS PARA O LOCAL DESEJADO": "DRA OBJEKTEN TILL ÖNSKAD PLATS",
  "menus.Dumper": "Spjäll",
  "menus.Aberto": "Öppen",
  "menus.Fechado": "Stängd",
  "menus.Intermitente": "Intermittent",
  "menus.Se o seu menu incluir itens sensíveis à uniformidade, recomendamos definir o Tempo de Estabilização entre 3:00 e 5:00 minutos. Caso contrário, você pode deixá-lo em 5 segundos.": "Om din meny innehåller produkter som är känsliga för jämn tillagning rekommenderar vi att stabiliseringstiden ställs in mellan 3:00 och 5:00 minuter. Annars kan du lämna den på 5 sekunder.",
  "menus.Selecione o menu que deseja exportar:": "Välj menyn som du vill exportera:",
  "menus.Temperatura de pré-aquecimento": "Förvärmningstemperatur",
  "menus.Temperatura de lastro": "Temperatur för bakyta",
  "menus.Temperatura de teto": "Taktemperatur",
  "menus.Volume de injeção de vapor (ml)": "Volym för ånginjektion (ml)",
  "menus.Parada de turbina": "Fläktstopp",
  "menus.Alta": "Hög",
  "menus.Média": "Medel",
  "menus.Baixa": "Låg",
  "menus.a": "till",
  "menus.Valor da injeção": "Injektionsvärde",
  "menus.Volume: até 999ml": "Volym: upp till 999 ml",
  "menus.Tempo: até 15 segundos": "Tid: upp till 15 sekunder",
  "menus.Tempo de injeção de vapor (seg)": "Tid för ånginjektion (sek)",
  "menus.Atenção!": "Observera!",
    "menus.Verifique as receitas do menu e ajuste os valores da Injeção de Vapor após alterar sua unidade de medida.": "Kontrollera recepten i menyn och justera värdena för ånginjektion efter att du har ändrat måttenheten.",
    "menus.Certifique-se de que a unidade de temperatura (°C ou °F) definida no equipamento seja a mesma que foi selecionada na criação do menu:": "Kontrollera att temperaturenheten (°C eller °F) som är inställd på utrustningen är densamma som valdes när menyn skapades:",
    "menus.Injeção desativada": "Injektion inaktiverad",
    "menus.Selecione a unidade de temperatura que está definida no equipamento:": "Välj den temperaturenhet som är inställd på utrustningen:",
    "menus.Clique para atualizar": "Klicka för att uppdatera",
    "menus.A função Atualização Forçada envia automaticamente o menu para os equipamentos selecionados, e que possuam versão compatível com este tipo de atualização, na próxima vez em que forem ligados. Os fornos que não estiverem atualizados ainda precisarão realizar o aceite manual.": "Funktionen Tvingad uppdatering skickar automatiskt menyn till de valda utrustningarna som har en version som är kompatibel med denna typ av uppdatering nästa gång de startas. Ugnar som ännu inte är uppdaterade måste fortfarande godkänna uppdateringen manuellt.",
    "menus.As opções selecionadas estarão disponíveis nos equipamentos que receberem este menu, podendo ser utilizadas pelo operador. É possível alterar estas configurações posteriormente no próprio forno ou pela plataforma.": "De valda alternativen kommer att vara tillgängliga på de utrustningar som tar emot denna meny och kan användas av operatören. Dessa inställningar kan senare ändras direkt på ugnen eller via plattformen.",
    "menus.Não foi possivel deletar as receitas": "Det gick inte att ta bort recepten",
    "menus.PRÉ": "FÖRV.",
    "menus.Speed Ovens": "Snabbugnar",
    "menus.Fornos Combinados": "Kombiugnar",
    "menus.Fornos de Panificação": "Bageriugnar",
    "menus.Após a criação, o tipo do menu não pode ser alterado. Ele só pode ser definido no momento da criação.": "När menyn har skapats kan dess typ inte ändras. Den kan endast väljas vid skapandet.",
    "menus.Pré-aquecimento do grupo": "Gruppförvärmning",
    "menus.Atenção: antes de transferir o menu de seu pen drive para o equipamento, é necessário descompactar o arquivo, transferindo a pasta PRATICA para o equipamento.": "Obs! Innan du överför menyn från USB-minnet till utrustningen måste filen packas upp och mappen PRATICA överföras till utrustningen.",
    "menus.Tamanho máximo": "Maximal storlek",
    "menus.Possibilita que o operador do forno crie parâmetros e os execute em seguida.": "Gör det möjligt för ugnsoperatören att skapa parametrar och använda dem direkt.",
    "menus.Acesso também à execução das receitas favoritas.": "Ger även åtkomst till att köra favoritrecept.",
    "menus.Possibilita que o operador adicione mais tempo para aquecer/dourar a refeição depois de sua execução.": "Gör det möjligt för operatören att lägga till mer tid för att värma/bryna maten efter att receptet har slutförts.",
    "menus.Possibilita a repetição da receita assim que sua execução é finalizada.": "Gör det möjligt att upprepa receptet direkt efter att det har slutförts.",
    "menus.Acesso exclusivo às receitas favoritas.": "Ger exklusiv åtkomst till favoritrecept.",
    "menus.Habilita o lembrete para o operador conferir se o alimento já está dentro do forno.": "Aktiverar en påminnelse så att operatören kontrollerar att maten redan finns i ugnen.",
    "menus.O forno importa automaticamente, ao ligar, um menu que esteja salvo em pen drive e nele inserido.": "Ugnen importerar automatiskt en meny som finns sparad på ett anslutet USB-minne när den startas.",
    "menus.Possibilita a cocção de diversos alimentos simultaneamente, um em cada GN.": "Gör det möjligt att tillaga flera livsmedel samtidigt, ett i varje GN.",
    "menus.Permite a execução de receitas pré programadas, vindas de fábrica.": "Ger möjlighet att köra fabriksförinstallerade recept.",
    "menus.Permite acesso à função turbo grill, que atinge até 300°C.": "Ger åtkomst till funktionen Turbo Grill, som når upp till 300 °C.",
    "menus.Possibilita que o operador adicione mais tempo para dourar a refeição depois de sua execução.": "Gör det möjligt för operatören att lägga till mer tid för att bryna maten efter att receptet har slutförts.",
    "menus.Permite que o operador edite grupos de receitas diretamente da tela inicial.": "Gör det möjligt för operatören att redigera receptgrupper direkt från startskärmen.",
    "menus.Copiar grupos": "Kopiera grupper",
    "menus.Excluir grupos": "Ta grupp borter",
    "menus.Copiar": "Kopiera",
    "menus.Selecione grupos para copiar": "Välj grupper att kopiera",
    "menus.Selecione o destino dos grupos": "Välj mål för grupperna",
    "menus.Colar": "Klistra i",
    "menus.Deseja cancelar a cópia e envio de grupos para os menus?": "Vill du avbryta kopieringen och överföringen av grupper till menyerna?",
    "menus.Grupos colados com sucesso": "{count, plural, one {Gruppen har klistrats in.} other {Grupperna har klistrats in.}}",
    "menus.Copiar receitas": "Kopiera recept",
    "menus.Selecione receitas para copiar": "Välj recept att kopiera",
        "menus.Selecione o destino das receitas": "Välj mål för recepten",
    "menus.Deseja cancelar a cópia e envio de receitas para os grupos?": "Vill du avbryta kopieringen och överföringen av recept till grupperna?",
    "menus.Receitas coladas com sucesso": "{count, plural, one {Receptet har klistrats in.} other {Recepten har klistrats in.}}",
    "menus.Converter para C-MAX EVO": "Konvertera till C-MAX EVO",
    "menus.Uma cópia deste menu, adaptada para o C-MAX EVO, será criada. Recomendamos que revise cuidadosamente todos os parâmetros dos passos e atualize as receitas com novas imagens, se julgar necessário.": "En kopia av denna meny, anpassad för C-MAX EVO, kommer att skapas. Vi rekommenderar att du noggrant granskar alla stegparametrar och uppdaterar recepten med nya bilder om det behövs.",
    "menus.Menu convertido com sucesso!": "Menyn har konverterats.",
    "menus.Não foi possível converter o menu. Tente novamente mais tarde": "Det gick inte att konvertera menyn. Försök igen senare.",
    "menus.O menu está sendo convertido... Aguarde!": "Menyn konverteras... Vänligen vänta!",
    "menus.Menu incompatível com": "Meny inkompatibel med",
    "menus.Selecione pelo menos um grupo": "Välj minst en grupp",
    "menus.Selecione pelo menos um menu": "Välj minst en meny",
    "menus.Menu atual": "Aktuell meny",
    "menus.Copiando grupos": "{count, plural, one {Gruppen kopieras... Vänligen vänta!} other {Grupperna kopieras... Vänligen vänta!}}",
    "menus.Erro ao copiar grupos": "{count, plural, one {Det gick inte att kopiera gruppen. Försök igen senare!} other {Det gick inte att kopiera grupperna. Försök igen senare!}}",
    "menus.Procurar pelo nome do menu": "Sök efter menynamn",
    "menus.Escolha um grupo de destino para cada menu selecionado": "Välj en målgrupp för varje vald meny!",
    "menus.Copiando receitas": "{count, plural, one {Receptet kopieras... Vänligen vänta!} other {Recepten kopieras... Vänligen vänta!}}",
    "menus.Erro ao copiar receitas": "{count, plural, one {Det gick inte att kopiera receptet. Försök igen senare!} other {Det gick inte att kopiera recepten. Försök igen senare!}}",
    "menus.SELECIONE GRUPOS PARA EXCLUIR": "VÄLJ GRUPPER ATT TA BORT",
    "menus.Padeiro noturno": "Nattbakning",
    "menus.Permite programar o início (pré-aquecimento) de uma receita específica ou informada manualmente (Modo Manual), sem a necessidade de presença de um operador no local.": "Gör det möjligt att schemalägga starten (förvärmningen) av ett specifikt recept eller ett manuellt angivet recept (Manuellt läge) utan att en operatör behöver vara på plats.",
    "menus.Vaporizador": "Ånggenerator",
    "menus.Editar receitas": "Redigera recept",
    "menus.Permite que o operador edite receitas diretamente da tela inicial.": "Gör det möjligt för operatören att redigera recept direkt från startskärmen.",
    "menus.Preencha o nome da receita": "Ange receptets namn",
    "menus.Tempo nível": "Tid nivå",
    "menus.Fermentadora": "Jässkåp",
    "menus.0 ou 5 a 59s": "0 eller 5 till 59 s",
    "menus.Selecione uma imagem": "Välj en bild",
    "menus.*Para criar receitas para fornos sem conectividade, crie um menu e então as receitas.": "*För att skapa recept för ugnar utan uppkoppling, skapa först en meny och därefter recepten.",
    "menus.CONVERTER": "KONVERTERA",
    "menus.Converter para FIT": "Konvertera till FIT",
    "menus.Converter para outro FIT": "Konvertera till en annan FIT",
    "menus.Selecione pelo menos um modelo FIT": "Välj minst en FIT-modell",
    "menus.O menu está sendo convertido para FIT... Aguarde!": "Menyn konverteras till FIT... Vänligen vänta!",
    "menus.{count} menu(s) convertido(s) com sucesso para FIT!": "{count} meny(er) har konverterats till FIT!",
    "menus.Alguns menus foram convertidos, mas houve falha em: {models}": "Vissa menyer konverterades, men följande misslyckades: {models}",
    "menus.Uma cópia deste menu será criada para cada modelo FIT selecionado, mantendo configurações, grupos, receitas e passos.": "En kopia av denna meny skapas för varje vald FIT-modell, med inställningar, grupper, recept och steg bevarade.",
    "menus.Uma cópia deste menu será criada para cada modelo FIT selecionado, mantendo configurações, grupos, receitas e passos. No entanto, como cada forno possui dimensões e características específicas, recomendamos revisar e ajustar os parâmetros para garantir o melhor desempenho e resultado em cada equipamento. Selecione o modelo da linha FIT para qual deseja converter o menu.": "En kopia av denna meny skapas för varje vald FIT-modell med inställningar, grupper, recept och steg bevarade. Eftersom varje ugn har specifika mått och egenskaper rekommenderar vi dock att parametrarna granskas och justeras för bästa prestanda och resultat på varje utrustning. Välj den FIT-modell som du vill konvertera menyn till.",

    //COOKBOOK
    "cookbook.RECEITAS DISPONÍVEIS": "TILLGÄNGLIGA RECEPT",
    "cookbook.RECEITAS SALVAS": "SPARADE RECEPT",
    "cookbook.ENVIAR PARA MENU": "SKICKA TILL MENY",
    "cookbook.SALVAR": "SPARA",
    "cookbook.salvar": "Spara",
    "cookbook.Filtrar por": "Filtrera efter",
    "cookbook.Procurar receita do cookbook": "Sök recept i Cookbook",
    "cookbook.Equipamento": "Utrustning",
    "cookbook.Ingrediente principal": "Huvudingrediens",
    "cookbook.Tipo de prato": "Rätttyp",
    "cookbook.Região": "Region Region Region Region",
    "cookbook.Pré-aquecimento": "Förvärmning",
    "cookbook.Procurar receita": "Sök recept",
    "cookbook.Menu": "Meny",
        "cookbook.ENVIAR": "SKICKA",
    "cookbook.Procurar nome do menu": "Sök menynamn",
    "cookbook.Escolha um grupo deste menu": "Välj en grupp i denna meny",
    "cookbook.Selecionar grupo": "Välj grupp",
    "cookbook.Tivemos um problema. Tente novamente mais tarde":
      "Ett problem uppstod. Försök igen senare.",
    "cookbook.Receita adicionada com sucesso!": "Receptet har lagts till.",
    "cookbook.Não foi possível adicionar a receita. Tente novamente mais tarde":
      "Det gick inte att lägga till receptet. Försök igen senare.",
    "cookbook.Selecione um menu e um grupo para enviar esta receita":
      "Välj en meny och en grupp för att skicka detta recept.",
    "cookbook.A receita não foi adicionada ao menu pois não há grupos criados":
      "Receptet lades inte till i menyn eftersom inga grupper har skapats.",
    "cookbook.Selecione o modelo do equipamento primeiro": "Välj utrustningsmodell först",
    "cookbook.Grupo": "Gruppgrupp",
    "cookbook.Não foi possível salvar os passos da receita": "Det gick inte att spara receptstegen",
    "cookbook.Bovina": "Nötkött",
    "cookbook.Frango": "Kyckling",
    "cookbook.Ovos": "Ägg",
    "cookbook.Pães": "Bröd",
    "cookbook.Peixes": "Fisk",
    "cookbook.Queijo": "Ost",
    "cookbook.Suína": "Fläsk",
    "cookbook.Vegetais": "Grönsaker",
    "cookbook.Outros": "Övrigt",
    "cookbook.Entradas/aperitivos": "Förrätter/Snacks",
    "cookbook.Principais": "Huvudrätter",
    "cookbook.Snacks": "Snacks",
    "cookbook.Pizzas": "Pizzor",
    "cookbook.Massas": "Pasta",
    "cookbook.Acompanhamentos": "Tillbehör",
    "cookbook.Sobremesas": "Desserter",
    "cookbook.Manhã": "Frukost",
    "cookbook.Padaria": "Bageri",
    "cookbook.Todos": "Alla",
    "cookbook.Não atribuir origem": "Tilldela inte ursprung",
    "cookbook.Brasil": "Brasilien",
    "cookbook.Alemanha": "Tyskland",
    "cookbook.França": "Frankrike",
    "cookbook.Rússia": "Ryssland",
    "cookbook.China": "Kina Kina",
    "cookbook.Japão": "Japanska Japan",
    "cookbook.Itália": "Italien Italien",
    "cookbook.Egito": "Egypten",
    "cookbook.Grécia": "Grekland",
    "cookbook.Argentina": "Argentina",
    "cookbook.África": "Afrika Afrika",
    "cookbook.Estados Unidos": "USA",
    "cookbook.Coreia": "Korea",
    "cookbook.Turquia": "Turkiet",
    "cookbook.Ideal para": "Passar för",
    "cookbook.Polônia": "Polen",
    "cookbook.Sanduíches": "Smörgåsar",
    "cookbook.Nova Receita": "Nytt recept",

    //EQUIPAMENTOS
    "equipment.equipamentos": "Typar",
    "equipment.procurar equipamento": "Sök utrustning eller användare",
    "equipment.adicionar equipamento": "lägg till utrustning",
    "equipment.atualizar equipamento": "uppdaterad",
    "equipment.+ equipamentos": "+ Typar",
    "equipment.buscar equipamento": "Sök utrustning",
    "equipment.Desvincular": "Koppla från",
    "equipment.Editar": "Redigera",
    "equipment.sem conteúdo": "DET FINNS INGEN UTRUSTNING HÄR ÄN :(",
    "equipment.description.sem conteúdo": "Klicka på knappen Lägg till utrustning uppe till höger för att ansluta dina ugnar.",
    "equipment.editar equipamento": "Redigera Typ",
    "equipment.equipamento editado com sucesso!": "Utrustningen har uppdaterats.",
    "equipment.não foi possível editar o equipamento. Tente novamente mais tarde": "Det gick inte att uppdatera utrustningen. Försök igen senare.",
    "equipment.Menu exportado com sucesso!": "Menyn har exporterats.",
    "equipment.Não foi possível exportar o menu. Tente novamente mais tarde": "Det gick inte att exportera menyn. Försök igen senare.",
    "equipment.Selecione pelo menos um equipamento para enviar o menu": "Välj minst en utrustning för att skicka menyn.",
    "equipment.Informações do menu": "Menyinformation",
    "equipment.Procurar receita ou grupo": "Sök recept eller grupp",
    "equipment.Grupo": "Gruppgrupp",
    "equipment.Receita": "Recept",
    "equipment.Quantidade": "Antal",
    "equipment.Receitas mais preparadas no equipamento durante o período": "Recept som har tillagats flest gånger på utrustningen under perioden",
    "equipment.Informações de limpeza": "Rengöringsinformation",
    "equipment.Data da limpeza": "Rengöringsdatum",
    "equipment.Hora da limpeza": "Rengöringstid",
    "equipment.nome": "Namn",
    "equipment.modelo": "Modell",
    "equipment.categoria": "Kategori",
    "equipment.loja": "Butik",
    "desvincular equipamento": "Koppla från utrustning",
    "equipment.unlink.paragrafo 1":
      "Vill du koppla från utrustningen från IOK-plattformen?",
    "equipment.unlink.paragrafo 2":
      "Efter detta kommer det inte längre att vara möjligt att hantera dess inställningar och meny via plattformen, om du inte ansluter utrustningen igen genom att följa anslutningsanvisningarna.",
    "equipamento desvinculado com sucesso!":
      "Utrustningen har kopplats från.",
    "equipment.ocorreu um erro. Tente novamente mais tarde":
      "Ett fel uppstod. Försök igen senare.",
    "equipment.sim": "Ja Ja Ja Ja Ja Ja Ja Ja Ja Ja Ja Ja Ja",
    "equipment.não": "Nej, nej.",
    "equipment.Encerrar acesso remoto": "Avsluta fjärråtkomst",
    "equipment.Horas sem limpeza": "Timmar utan rengöring",
    "equipment.Histórico de eventos": "Händelsehistorik",
    "equipment.Histórico de eventos do forno": "Ugnens händelsehistorik",
    "equipment.Histórico de eventos da fermentadora": "Jäsarens händelsehistorik",
    "equipment.Receitas executadas": "Tillagade recept",
    "equipment.Hoje": "Idag",
    "equipment.Tempo de porta aberta": "Tid med öppen dörr",
    "equipment.Tempo médio aproximado": "Genomsnittlig ungefärlig tid",
    "equipment.Filtrar eventos": "Filtrera händelser",
    "equipment.Evento": "Händelse",
    "equipment.Data": "Datum",
    "equipment.ERRO SENSOR RI": "Fel på nedre värmeelementssensorn",
    "equipment.ERRO COM INV. DE FREQ.": "Fel på frekvensomriktaren",
    "equipment.ERRO MAGNETRON": "Magnetronfel",
    "equipment.ERRO SENSOR CAMARA": "Fel på kammarsensorn",
    "equipment.ERRO CAN": "CAN-Fel",
        "equipment.Erro INVERSOR DE FREQUENCIA": "Fel på frekvensomriktaren",
    "equipment.ERRO DO MODELO DO EQUIPAMENTO": "Fel på utrustningsmodell",
    "equipment.ERRO PAINEL": "Panelfel",
    "equipment.ERRO INV.FREQ.STATUS": "Statusfel på frekvensomriktaren",
    "equipment.ERRO SENSOR BOARD": "Fel på kortsensor",
    "equipment.ERRO ENERGY": "Energifel",
    "equipment.ERRO I2C": "I2C-fel",
    "equipment.EQUIPAMENTO LIGADO": "Utrustning påslagen",
    "equipment.EQUIPAMENTO DESLIGADO": "Utrustning avstängd",
    "equipment.Plataforma": "Plattform",
    "equipment.Forno": "Ugn",
    "equipment.Origem": "Ursprung",
    "equipment.Locais": "Platser",
    "equipment.não foi possível carregar as entidades": "Det gick inte att läsa in enheterna",
    "equipment.conceder acesso remoto a": "Ge fjärråtkomst till",
    "equipment.atualizar software": "uppdaterad programvara",
    "equipment.suporte": "Supportstöd",
    "equipment.PIN": "PIN",
    "equipment.nome do equipamento": "Utrustningens namn",
    "equipment.vinculado à loja": "Kopplad till butik",
    "equipment.cadastrar loja": "Registrera butik",
    "equipment.informe o PIN do forno": "Ålder ugnens PIN",
    "equipment.preencha o PIN do forno": "Fyll i ugnens PIN",
    "equipment.adicione um nome para facilitar seu reconhecimento":
      "Lägg till ett namn för enklare identifiering",
    "equipment.preencha o nome do equipamento":
      "Fyll i Typens Namn",
    "equipment.selecionar": "Välj",
    "equipment.nome fantasia": "Företagsnamn",
    "equipment.informe o nome fantasia": "Ange företagsnamnet",
    "equipment.preencha o nome fantasia": "Fyll i företagsnamnet",
    "equipment.CNPJ": "CNPJ",
    "equipment.XX.XXX.XXX/0001.XX": "XX.XXX.XX/0001.XX",
    "equipment.preencha o CNPJ": "Fyll i CNPJ",
    "equipment.CEP": "Postnummer",
    "equipment.00000-000": "00000-000",
    "equipment.preencha o CEP": "Fyll i postnumret",
    "equipment.cidade": "Stad",
    "equipment.informe a cidade": "Ange Stad",
    "equipment.preencha a cidade": "Fyll i stad",
    "equipment.UF": "Delstat",
    "equipment.bairro": "Stadsdel",
    "equipment.informe o bairro": "Ålder stadsdel",
    "equipment.endereço": "Adress",
    "equipment.informe o seu endereço": "Ålder Din Adress",
    "equipment.preencha o seu endereço": "Fyll i Din Adress",
    "equipment.Nº": "Nr",
    "equipment.equipamento cadastrado com sucesso!":
      "Utrustningen har registrerats.",
    "equipment.ocorreu um erro": "Ett fel uppstod",
    "equipment.preencha o modelo": "Fyll i modell",
    "equipment.selecione uma categoria": "Välj en kategori",
    "equipment.selecione uma loja": "Välj en butik",
    "equipment.preencha o bairro": "Fyll i stadsdel",
    "equipment.não foi possível cadastrar o equipamento. Tente novamente mais tarde":
      "Det gick inte att registrera utrustningen. Försök igen senare.",
    "equipment.loja cadastrada com sucesso": "Butiken har registrerats.",
    "equipment.não foi possível cadastrar a loja. Tente novamente mais tarde":
      "Det gick inte att registrera butiken. Försök igen senare.",
    "equipment.equipment": "Typar",
    "equipment.search equipment": "sök utrustning",
    "equipment.add equipment": "lägg till utrustning",
    "equipment.update equipment": "uppdaterad",
    "equipment.plus equipment": "+ utrustning",
    "equipment.Procurar equipamento": "Sök utrustning",
    "equipment.EQUIPAMENTOS": "UTRUSTNINGAR",
    "equipment.Atualizar equipamento": "Uppdatera Typ",
    "equipment.Atualizar equipamentos": "Uppdatera Typar",
    "equipment.confirmar": "bekräfta",
    "equipment.Selecione os modelos que deseja atualizar:": "Välj de modeller du vill uppdatera:",
    "equipment.Como deseja realizar a atualização?": "Hur vill du genomföra uppdateringen?",
    "equipment.Enviar atualização pela plataforma (internet)": "Skicka uppdatering via plattformen (internet)",
    "equipment.Salvar arquivo de atualização no dispositivo": "Spara uppdateringsfil på enheten",
    "equipment.Linha Express": "Express-serien",
    "equipment.Escolha como deseja realizar a atualização": "Välj hur du vill genomföra uppdateringen",
    "equipment.Selecione ao menos um modelo de equipamento para atualizar": "Välj minst en utrustningsmodell att uppdatera",
    "equipment.Status: ": "Status: ",
    "equipment.Número de série:": "Serienummer:",
    "equipment.Menu:": "Meny:",
    "equipment.Status:": "Status:",
    "equipment.Número de série": "Serienummer",
    "equipment.Menu": "Meny",
    "equipment.Loja: ": "Butik: ",
    "equipment.End:": "Adr:: ",
    "equipment.Endereço:": "Adress: ",
    "equipment.Cidade:": "Stad: ",
    "equipment.CEP:": "Postnummer: ",
        "equipment.Atualização de software enviada com sucesso!": "Programuppdateringen har skickats.",
    "equipment.Não foi possível enviar a atualização de software. Tente novamente mais tarde": "Det gick inte att skicka programuppdateringen. Försök igen senare.",
    "equipment.Download realizado com sucesso": "Nedladdningen slutfördes.",
    "equipment.Não foi possível realizar o download. Tente novamente mais tarde": "Det gick inte att genomföra nedladdningen. Försök igen senare.",
    "equipment.Solicitação processada com erro. Tente novamente mais tarde": "Begäran behandlades med fel. Försök igen senare.",
    "equipment.Preencha o nome da versão": "Fyll i versionsnamnet",
    "equipment.Informe aqui todas as alterações desta nova versão": "Ange alla ändringar i den här nya versionen här",
    "equipment.Nova versão de software atualizada com sucesso!": "Den nya programversionen har uppdaterats.",
    "equipment.Informe pelo menos uma mudança nesta versão": "Ange minst en ändring i den här versionen",
    "equipment.Falha ao transformar o arquivo em Blob": "Det gick inte att konvertera filen till Blob",
    "equipment.Erro ao criar Blob a partir do arquivo": "Fel vid skapande av Blob från filen",
    "equipment.Falha ao ler o arquivo": "Det gick inte att läsa filen",
    "equipment.selecionar tipo": "välj typ",
    "equipment.selecione o tipo da versão": "välj versionstyp",
    "equipment.atualização": "UPPDATERING",
    "equipment.Selecione abaixo o que deseja fazer:": "Välj nedan vad du vill göra:",
    "equipment.Atualizar meus equipamentos": "Uppdatera Min Typar",
    "equipment.Enviar atualização para usuários selecionados": "Skicka uppdatering till valda användare",
    "equipment.ENVIAR": "SKICKA",
    "equipment.ENVIAR ATUALIZAÇÃO": "SKICKA UPPDATERING",
    "equipment.Selecione os e-mails para os quais deseja enviar a atualização:": "Välj de e-postadresser som uppdateringen ska skickas till:",
    "equipment.A atualização disponibilizada no dia": "Uppdateringen som gjordes tillgänglig den ",
    "equipment.referente ao equipamento": "för utrustningen ",
    "equipment.contempla o seguinte:": "omfattar följande:",
    "equipment.Selecionar arquivo para envio": "Välj fil att skicka",
    "equipment.Por favor, selecione um arquivo .tar": "Välj en .tar-fil",
    "equipment.Selecione o modelo do equipamento:": "Välj utrustningsmodell:",
    "equipment.Selecione uma opção": "Välj ett alternativ",
    "equipment.Nomeie a versão": "Namnge versionen",
    "equipment.Clique sobre o arquivo que deseja baixar:": "Klicka på filen du vill ladda ner:",
    "equipment.Baixar atualização": "Ladda ner  ner uppdatering",
    "equipment.Versões": "Versioner",
    "equipment.e superiores": "och senare",
    "equipment.name": "namn",
    "equipment.model": "modellmodellmodell",
    "equipment.category": "Kategorier",
    "equipment.store": "butik",
    "FIT Express/FIT ST": "FIT Express/FIT ST",
    "Copa/Single Mag/Rocket": "Copa/Single Mag/Rocket",
    "Forza STi": "Forza STi",
    "TSi": "TSi",
    "FIT Express": "FIT Express",
    "FIT ST": "FIT ST",
    "FIT Express, FIT ST": "FIT Express, FIT ST",
    "Copa Express, Rocket Express, Copa Single Mag": "Copa Express, Rocket Express, Copa Single Mag",
    "equipment.e": "och",
    "equipment.Últimas versões de software:": "Senaste programvaruversionerna: ",
    "equipment.Você não possui nenhum equipamento desatualizado": "Du har ingen utrustning med inaktuell programvara",
    "equipment.grupos": "Grupper",
    "equipment.não foi possível carregar os grupos de equipamentos da companhia": "Det gick inte att läsa in företagets utrustningsgrupper",
    "equipment.vinculado ao grupo": "Kopplad till grupp",
    "equipment.selecione um grupo": "Välj en grupp",
    "equipment.cadastrar grupo": "Registrera grupp",
    "equipment.Número de Série": "SN",
    "equipment.Versão": "Version",
    "equipment.não foi possível cadastrar o equipamento. Selecione ou cadastre um grupo": "Det gick inte att registrera utrustningen. Välj eller registrera en grupp",
    "equipment.CRIE GRUPOS DE EQUIPAMENTOS!": "SKAPAR UTRUSTNINGSGRUPPER!",
    "equipment.Para que os usuários vinculados à conta possam visualizar os equipamentos você precisa:": "För att användare som är kopplade till kontot ska kunna se utrustningen behöver du:",
    "equipment.1) Criar grupo(s);": "1) Skapa grupp(er);",
    "equipment.2) Atribuir equipamento(s) ao grupo;": "2) Tilldela utrustning till gruppen;",
    "equipment.3) Atribuir usuário(s) ao grupo.": "3) Tilldela användare till gruppen.",
    "equipment.Status software": "Programvarustatus",
    "equipment.Status menu": "Menystatus",
    "equipment.Pendente": "Väntande",
    "equipment.Aceito": "Godkänd",
    "equipment.Recusado": "Avvisad",
    "equipment.Atualizar software": "Uppdatera programvara",
    "equipment.Deseja enviar a atualização para o equipamento selecionado?": "Vill du skicka uppdateringen till den valda utrustningen?",
    "equipment.Companhia": "Företag",
    "equipment.Exportar menu": "Exportera meny",
    "equipment.companhias": "företag",
    "equipment.Nome da companhia": "Företagsnamn",
    "equipment.Procurar equipamento, usuário ou companhia": "Sök utrustning, användare eller företag",
    "equipment.Versão da power": "Power-version",
    "equipment.AINDA NÃO HÁ DADOS DE RECEITAS AQUI :(": "DET FINNS INGA RECEPTDATA HÄR ÄN :(",
    "equipment.AINDA NÃO HÁ DADOS DE LIMPEZAS AQUI :(": "DET FINNS INGA RENGÖRINGSDATA HÄR ÄN :(",
    "equipment.AINDA NÃO HÁ DADOS DE EVENTOS AQUI :(": "DET FINNS INGA HÄNDELSEDATA HÄR ÄN :(",
    "ID": "ID",
    "equipment.Hora": "Tid",
    "equipment.EVENTOS MAIS OCORRIDOS NO EQUIPAMENTO DURANTE O PERÍODO": "VANLIGASTE HÄNDELSERNA PÅ UTRUSTNINGEN UNDER PERIODEN",
    "equipment.hour": "tim",
    "equipment.minutes": "Min min min min min",
    "equipment.date format": "DD/MM/ÅÅÅÅ",
    "equipment.preparada": "tillagad",
    "equipment.vezes": "gånger",
    "equipment.vez": "gång",
    "equipment.Ver": "Visa visum",
    "equipment.Os dados são mantidos pela plataforma pelo tempo necessário para suporte, manutenção e evolução dos produtos.": "Data lagras på plattformen så länge som behövs för support, underhåll och vidareutveckling av produkterna.",
    "equipment.Ligado": "På",
    "equipment.Desligado": "Av",
    "equipment.CAN ERROR": "CAN-Fel",
    "equipment.CAMERA SENSOR ERROR": "Fel på kammarsensorn",
    "equipment.STEAM/RI SENSOR ERROR": "Fel på RI-sensorn",
    "equipment.PROBE 1 ERROR": "Varning sond 1",
    "equipment.PROBE 2 ERROR": "Varning sond 2",
    "equipment.PROBE 3 ERROR": "Varning sond 3",
    "equipment.PROBE 4 ERROR": "Varning sond 4",
    "equipment.PROBE 5 ERROR": "Varning sond 5",
    "equipment.PROBE 6 ERROR": "Varning sond 6",
    "equipment.GENERAL PROBE ERROR": "Allmänt sondfel",
    "equipment.WATER LACK ERROR": "Varning om vattenbrist",
    "equipment.HIGH PANEL TEMPERATURE ERROR": "Varning för hög paneltemperatur",
    "equipment.FREQUENCY INVERTER GENERAL ERROR": "Allmänt fel på frekvensomriktaren",
    "equipment.FREQUENCY INVERTER COMMUNICATION ERROR": "Kommunikationsvarning för frekvensomriktaren",
    "equipment.FREQUENCY INVERTER STATUS ERROR": "Statusvarning för frekvensomriktaren",
    "equipment.CLEANING NOT COMPLETED ERROR": "Varning om ofullständig rengöring",
    "equipment.MAGNETRON ERROR": "Magnetronvarning",
    "equipment.EQUIPMENT FAMILY/MODEL ERROR": "Fel på utrustningsmodell",
    "equipment.BOARD TEMPERATURE SENSOR ERROR": "Varning för kretskortets temperatursensor",
    "equipment.ENERGY MODULE ERROR": "Fel på energimodulen",
    "equipment.POWER BOARD I2C BUS ERROR": "Fel på Power-kortet",
    "equipment.GAS SYSTEM ERROR": "Gasfel",
    "equipment.VERY HIGH PANEL TEMPERATURE ERROR": "Fel: mycket hög paneltemperatur",
    "equipment.POWER ON": "På",
    "equipment.POWER OFF": "Av",
    "equipment.DOOR OPENED": "Dörr öppnad",
    "equipment.DOOR CLOSED": "Dörr stängd",
    "equipment.CLEANING CANCELED ERROR": "Rengöring avbruten av användaren",
    "equipment.PIN não encontrado. Por favor, verifique e tente novamente": "PIN-koden hittades inte. Kontrollera och försök igen.",
    "equipment.Ultracongeladores": "Snabbkylare",
    "equipment.PIN já vinculado a outra conta": "PIN-koden är redan kopplad till ett annat konto",
    "equipment.Equipamento já cadastrado nesta conta": "Utrustningen är redan registrerad på det här kontot",
    "equipment.Não foi possível validar o PIN. Tente novamente": "PIN-koden kunde inte valideras. Försök igen",
    "equipment.Modelo definido pelo equipamento": "Definieras av utrustningen",
    "equipment.Número de série offline inválido": "Ange sju siffror utan mellanslag eller inledande nolla",
    "equipment.Número de série já cadastrado": "Serienumret är redan registrerat",
    "equipment.Online": "På",
    "equipment.Offline": "Av",
        "equipment.Exibir apenas eventos": "Visa endast händelser",
    "equipment.Endereço": "Adress",
    "equipment.EQUIPMENT CONNECTED TO THE PLATFORM": "Utrustning ansluten till plattformen",
    "equipment.EQUIPMENT DISCONNECTED FROM THE PLATFORM": "Utrustning frånkopplad från plattformen",
    "equipment.MENU RECEIVED FROM THE PLATFORM": "Meny från plattformen godkänd av användaren",
    "equipment.MENU REJECTED BY THE USER": "Meny från plattformen avvisad av användaren",
    "equipment.CONNECTED TO THE INTERNET": "Ansluten till internet",
    "equipment.DISCONNECTED FROM THE INTERNET": "Frånkopplad från internet",
    "equipment.Infelizmente, não há versões compatíveis com este equipamento que realizem o envio de dados.": "Tyvärr finns det inga kompatibla versioner för denna utrustning som stöder dataöverföring.",
    "equipment.O equipamento": "Utrustningen",
    "equipment.deve ser atualizado para a versão mais recente de software para que passe a enviar os dados para a plataforma": "måste uppdateras till den senaste programvaruversionen för att kunna skicka data till plattformen",
    "equipment.Versão do seu equipamento": "Din utrustning version",
    "equipment.Versão disponível": "Tillgänglig version",
    "equipment.Selecione abaixo como deseja enviar a atualização para seu equipamento": "Välj nedan hur du vill skicka uppdateringen till din utrustning",
    "equipment.Salvar no dispositivo": "Spara på enheten",
    "equipment.Enviar pela internet": "Skicka via internet",
    "equipment.Cliente": "Kund Kund Kund",
    "equipment.NÚMERO DE SÉRIE NÃO ENCONTRADO": "SERIENUMRET HITTADES INTE",
    "equipment.BUSCAR": "SÖK",
    "equipment.ACESSADOS RECENTEMENTE": "SENAST ÖPPNADE",
    "equipment.SEM BUSCAS RECENTES": "INGA SENASTE SÖKNINGAR",
    "equipment.description.SEM BUSCAS RECENTES": "Använd serienumret för att söka efter utrustning.",
    "equipment.Procurar equipamento pelo número de série": "Sök utrustning med serienummer",
    "equipment.AIR FILTER CLEANING COMPLETED": "Rengöring av luftfilter slutförd",
    "equipment.AIR FILTER CLEANING REJECTED": "Rengöring av luftfilter avvisad",
    "equipment.CATALYTIC FILTER CLEANING COMPLETED": "Rengöring av katalytiskt filter slutförd",
    "equipment.CATALYTIC FILTER CLEANING REJECTED": "Rengöring av katalytiskt filter avvisad",
    "equipment.Endereço (rua, avenida, rodovia)": "Adress (gata, aveny, väg)",
    "equipment.Nº/Km": "Nr/Km",
    "equipment.ID do equipamento": "Utrustnings-ID",
        "equipment.Todo equipamento deve ser vinculado a um grupo. Selecione um grupo da lista ou cadastre um novo clicando em + Cadastrar grupo.": "All utrustning måste vara kopplad till en grupp. Välj en grupp från listan eller registrera en ny genom att klicka på + Registrera grupp.",
    "equipment.Nomeie seu forno": "Namnge din ugn",
    "equipment.Para visualizar o PIN, acesse nas configurações do equipamento a Plataforma Virtual IOK.": "För att visa PIN-koden, öppna IOK Virtual Platform i utrustningens inställningar.",
    "equipment.Vinculação IOK": "IOK-koppling",
   "equipment.Preparações": "Tillagningar",
    "equipment.recipeTable.recipe": "Recept",
    "equipment.recipeTable.origin": "Urs.",
    "equipment.recipeTable.executions": "Körn.",
    "equipment.recipeTable.lastExecution": "Senaste körning",
    "equipment.Última preparação": "Senaste tillagning",
    "equipment.localização": "Plats",
    "equipment.AINDA NÃO HÁ NENHUMA LOCALIZAÇÃO CADASTRADA :(": "DET FINNS ÄNNU INGA REGISTRERADE PLATSER :(",
    "equipment.description.AINDA NÃO HÁ NENHUMA LOCALIZAÇÃO CADASTRADA :(": "Klicka på knappen uppe till höger för att lägga till platser.",
    "equipment.Procurar empresa ou local": "Sök företag eller plats",
    "equipment.Adicionar localização": "Lägg till plats",
    "equipment.espaço": "Utrymme",
    "equipment.local": "Platser",
    "equipment.EXCLUIR LOCALIZAÇÃO": "TA PLATS BORT",
    "equipment.Você deseja excluir esta localização?": "Vill du ta bort denna plats?",
    "equipment.Ao fazer isso, os equipamentos atrelados à ela não exibirão nenhuma localização, sendo necessário informar um novo local para eles.": "Om du gör detta kommer utrustning som är kopplad till platsen inte längre att visa någon plats. Du måste ange en ny plats för dem.",
    "equipment.Localização deletada com sucesso!": "Platsen har tagits bort.",
    "equipment.Erro ao deletar a localização. Tente novamente mais tarde": "Fel vid borttagning av platsen. Försök igen senare.",
    "equipment.Não foi possivel deletar a localização": "Det gick inte att ta bort platsen.",
    "equipment.Localização adicionada com sucesso!": "Platsen har lagts till.",
    "equipment.Não foi possível adicionar a localização. Tente novamente mais tarde": "Det gick inte att lägga till platsen. Försök igen senare.",
    "equipment.Nome do espaço": "Namn på utrymmet",
    "equipment.Informe o nome do espaço": "Ange namnet på utrymmet",
    "equipment.Preencha o nome do espaço": "Fyll i namnet på utrymmet",
    "equipment.país": "Landet",
    "equipment.informe o país": "Ange land",
    "equipment.preencha o país": "Fyll i land",
    "equipment.Localização editada com sucesso!": "Platsen har uppdaterats.",
    "equipment.Não foi possível editar a localização. Tente novamente mais tarde": "Det gick inte att uppdatera platsen. Försök igen senare.",
    "equipment.Editar localização": "Redigera plats",
    "equipment.Pico de preparações": "Topptider för tillagningar",
    "equipment.informações da semana": "veckoinformation",
    "equipment.horários de pico": "Topptider",
    "equipment.horário de pico": "Topptid",
    "equipment.preparações do dia": "Dagar tillagningar",
    "equipment.Horário": "Tid",
    "equipment.dia selecionado": "vald dag",
        "equipment.A limpeza adequada e diária do forno auxilia em seu funcionamento correto e impacta na garantia.": "Korrekt daglig rengöring av ugnen bidrar till att den fungerar korrekt och påverkar garantin.",
    "equipment.Total de limpezas realizadas:": "Totalt antal utförda rengöringar:",
    "equipment.Limpezas não concluídas:": "Ej slutförda rengöringar:",
    "equipment.Desde a vinculação do forno a IOK": "Sedan ugnen kopplades till IOK",
    "equipment.Equipamento ligado há:": "Utrustningen har varit påslagen i:",
    "equipment.Total de receitas preparadas:": "Totalt tillagade recept:",
    "equipment.Receitas preparadas": "Tillagade recept",
    "equipment.Aberturas de porta": "Dörröppningar",
    "equipment.Desde a última vez que o forno foi ligado": "Sedan ugnen | Startades",
    "equipment.Preparação": "Tillagning",
    "equipment.Nenhuma localização criada": "Ingen plats har skapats",
    "equipment.Acesso remoto": "Fjärråtkomst",
    "equipment.Informe o ID da empresa que poderá acessar remotamente seu forno. Use ; para separar IDs.": "Ange ID för det företag som ska kunna få fjärråtkomst till din ugn. Använd ; för att separera flera ID:n.",
    "equipment.O acesso remoto permite que as empresas selecionadas enviem menus e atualizações para seu equipamento.": "Fjärråtkomst gör det möjligt för de valda företagen att skicka menyer och uppdateringar till din utrustning.",
    "equipment.Concedo acesso remoto à Prática oficial.": "Jag ger Prática officiell fjärråtkomst.",
    "equipment.Deseja selecionar outros equipamentos vinculados à sua conta para conceder acesso remoto a eles?": "Vill du välja andra utrustningar som är kopplade till ditt konto för att ge dem fjärråtkomst?",
    "equipment.Selecione abaixo os equipamentos para os quais deseja conceder acesso remoto à": "Välj nedan de utrustningar som du vill ge fjärråtkomst till",
    "equipment.Acesso remoto concedido com sucesso!": "Fjärråtkomst har beviljats.",
    "equipment.Selecione pelo menos um equipamento": "Välj minst en utrustning",
    "equipment.Não foi possível editar os equipamentos. Tente novamente mais tarde": "Det gick inte att uppdatera utrustningarna. Försök igen senare.",
    "equipment.Solicitar atendimento": "Begär service",
    "equipment.Relate um problema": "Beskriv ett problem",
    "equipment.Descreva aqui o problema de seu equipamento": "Beskriv problemet med din utrustning här",
    "equipment.Não foi possível enviar sua solicitação de atendimento. Tente mais tarde": "Det gick inte att skicka din servicebegäran. Försök igen senare.",
    "equipment.Solicitação técnica enviada com sucesso!": "Servicebegäran har skickats.",
    "equipment.Enviar": "Skicka",
    "equipment.Solicitação de atendimento": "Servicebegäran",
    "equipment.Informe o problema de seu equipamento": "Beskriv problemet med din utrustning",
    "equipment.Informações do magnetron": "Magnetroninformation",
    "equipment.Vida útil aproximada": "Uppskattad livslängd",
        "equipment.MAGNETRON USAGE HOURS": "Magnetronens användningstimmar",
    "equipment.Atendimento": "Serviceservice",
    "equipment.Eventos mais ocorridos no equipamento durante o período": "Vanligaste händelserna på utrustningen under perioden",
    "equipment.EQUIPAMENTO SEM NÚMERO DE SÉRIE": "UTRUSTNING UTAN SERIENUMMER",
    "equipment.Filtros": "Filter",
    "equipment.Filtrar": "Filtrera",
    "equipment.Limpar filtros": "Rensa filter",
    "equipment.Procurar por modelo, versão ou país": "Sök efter modell, version eller land",
    "equipment.Procurar equipamento, NS, modelo, versão ou país": "Sök efter utrustning, serienummer, modell, version eller land",
    "equipment.Os seguintes IDs não pertencem a uma companhia do tipo 'Distribuidor' e foram removidos": "Följande ID:n tillhör inte ett företag av typen 'Distributör' och har tagits bort",
    "equipment.BAIXAR VERSÕES": "LADDA NER VERSIONER",
    "equipment.Compatível com todas as versões da IHM.": "Kompatibel med alla IHM-versioner.",
    "equipment.Compatível apenas com a versão 2.0.0C da Power.": "Kompatibel endast med Power-version 2.0.0C.",
    "equipment.Procurar evento": "Sök händelse",
    "equipment.Forno conectado": "Ugn ansluten",
    "equipment.Limpeza de filtro de ar": "Rengöring av luftfilter",
    "equipment.Limpeza de filtro catalítico": "Rengöring av katalytiskt filter",
    "equipment.Limpeza realizada": "Rengöring utförd",
    "equipment.Limpeza recomendada": "Rekommenderad rengöring",
    "equipment.Forno ligado": "Ugn påslagen",
    "equipment.Inversor de frequência": "Frekvensomriktare",
    "equipment.Temperatura de painel": "Paneltemperatur",
    "equipment.Sensor da câmara": "Kammarsensor",
    "equipment.Magnetron": "Magnetron",
    "equipment.Power": "Kraftkraft",
    "equipment.Informações de menu": "Menyinformation",
    "equipment.Limpeza": "Rengöring",
    "equipment.O equipamento já está utilizando a versão mais recente do software.": "Utrustningen använder redan den senaste programvaruversionen.",
    "equipment.Atenção: o cálculo da vida útil do magnetron não considera o tempo de uso anterior à versão F1.1.0.": "Observera: beräkningen av magnetronens livslängd tar inte hänsyn till användningstid före version F1.1.0.",
    "equipment.Equipamentos com erro": "Utrustningar med fel",
    "equipment.Em breve você terá acesso a dados importantes enviados pelo forno, como horário de pico, receitas mais executadas, histórico de higienizações, eventos ocorridos e mais! Lembre-se de manter seu equipamento sempre atualizado com as novas versões disponíveis na plataforma.":
      "Snart kommer du att få tillgång till viktiga data som skickas från ugnen, såsom tider med högst användning, mest tillagade recept, rengöringshistorik, inträffade händelser och mycket mer! Kom ihåg att alltid hålla din utrustning uppdaterad med de senaste versionerna som finns tillgängliga på plattformen.",
    "equipment.Para que a execução da limpeza seja registrada no equipamento e enviada à plataforma, é necessário seguir o passo a passo completo do procedimento no forno. Não é obrigatório assistir aos vídeos dos passos, quando disponíveis.":
      "För att rengöringen ska registreras i utrustningen och skickas till plattformen måste hela rengöringsproceduren följas steg för steg i ugnen. Det är inte obligatoriskt att titta på instruktionsvideorna för stegen när de finns tillgängliga.",
    "equipment.Horas de uso": "Användningstimmar",
        "equipment.A contagem das horas de uso do magnetron são realizadas a partir da versão F1.0.6": "Räkningen av magnetronens användningstimmar sker från och med version F1.0.6.",
    "equipment.A atualização do software leva cerca de 15 minutos. Durante o processo, o forno reiniciará e exibirá uma blå skärm tills uppdateringen är klar. För att undvika fel, håll ugnen påslagen och ansluten till internet. Om du väljer att uppdatera via USB-minne, ta inte bort det förrän uppdateringen är slutförd.": "Programvaruuppdateringen tar cirka 15 minuter. Under processen startar ugnen om och visar en blå skärm tills uppdateringen är slutförd. För att undvika fel ska ugnen vara påslagen och ansluten till internet. Om du väljer att uppdatera via USB-minne, ta inte bort det förrän uppdateringen är slutförd.",
    'equipment.Equipamento {name} com software {version} devem ser atualizador via USB. A atualização do software leva cerca de 15 minutos. Durante o processo, o forno reiniciará e exibirá uma tela azul até a conclusão. Para evitar falhas, mantenha-o ligado e conectado à internet. Caso opte por atualizar via pen drive, não o remova até a conclusão.': "Utrustning {name} med programvara {version} måste uppdateras via USB. Programvaruuppdateringen tar cirka 15 minuter. Under processen startar ugnen om och visar en blå skärm tills uppdateringen är slutförd. För att undvika fel ska ugnen vara påslagen och ansluten till internet. Om du väljer att uppdatera via USB-minne, ta inte bort det förrän uppdateringen är slutförd.",
    "equipment.Observação": "Anmärkning:",
    "equipment.Para versões ST2.0.0 e superiores, o envio de atualização pela plataforma (Wi-fi) seguirá disponibilizado normalmente.": "För versioner ST2.0.0 och senare kommer uppdateringar via plattformen (Wi-Fi) även fortsättningsvis att vara tillgängliga som vanligt.",
    "equipment.Aqui você encontra informações gerais sobre o equipamento;": "Här hittar du allmän information om utrustningen;",
    "equipment.Ao clicar nestes botões você consegue solicitar atendimento para seu forno e exportar seus dados em planilhas do Excel;": "Genom att klicka på dessa knappar kan du begära service för din ugn och exportera dina data till Excel-kalkylblad;",
    "equipment.Nos quadros abaixo você encontra informações detalhadas sobre execuções de receitas;": "I rutorna nedan hittar du detaljerad information om receptkörningar;",
    "equipment.Horário de pico;": "Topptid;",
    "equipment.Informações referentes a higienização;": "Information om rengöring;",
    "equipment.E histórico de eventos;": "Och händelsehistorik;",
    "equipment.Lembre-se de que é necessário selecionar o período do qual deseja visualizar os dados. É possível fazer isso ao clicar sobre o calendário dos quadros e ao selecionar filtros.": "Kom ihåg att välja den period vars data du vill visa. Du kan göra detta genom att klicka på kalendern i rutorna och använda filtren.",
    "equipment.Baixando o arquivo... Ele estará disponível em breve!": "Laddar ner filen... Den kommer snart att vara tillgänglig!",
    "equipment.A contagem das horas de uso do magnetron são realizadas a partir da versão F1.1.0": "Räkningen av magnetronens användningstimmar sker från och med version F1.1.0.",
    "equipment.Data de fabricação": "Tillverkningsdatum",
    "equipment.manutenção": "underhåll",
    "equipment.Ao buscar e localizar um número de série, será aberto um canal temporário diretamente com o forno, permitindo o compartilhamento de seus dados de manutenção. Esses dados não serão armazenados na plataforma, sendo necessário realizar uma nova busca sempre que desejado.": "När du söker efter och hittar ett serienummer öppnas en tillfällig anslutning direkt till ugnen, vilket möjliggör delning av dess underhållsdata. Dessa uppgifter lagras inte på plattformen, så en ny sökning måste göras varje gång du vill komma åt dem.",
    "equipment.INFORME UM NÚMERO DE SÉRIE E CLIQUE EM BUSCAR": "ANGE ETT SERIENUMMER OCH KLICKA PÅ SÖK",
    "equipment.Apenas os modelos FIT Express / FIT Single Mag / FIT XL com a versão de software F2.1.0 enviarão dados de manutenção. As informações, principalmente as dos contadores, serão contabilizadas a partir dessa versão.": "Endast modellerna FIT Express / FIT Single Mag / FIT XL med programvaruversion F2.1.0 skickar underhållsdata. Informationen, särskilt räknarvärdena, börjar registreras från och med denna version.",
    "equipment.Procurar número de série": "Sök serienummer",
    "equipment.ENCERRAR SESSÃO": "AVSLUTA SESSION",
    "equipment.Alerta": "Varning",
    "equipment.Local": "Platser",
    "equipment.Software": "Programvara",
    "equipment.Forno sem limpeza há": "Ugnen har inte rengjorts på",
    "equipment.Horário de pico": "Topptid",
    "equipment.HP": "HP",
    "equipment.RECIPE STARTED": "Recept startat",
        "equipment.RECIPE CANCELED": "Recept avbrutet av användaren",
    "equipment.RECIPE COMPLETED": "Recept slutfört",
    "equipment.DOOR OPENED RECIPE": "Luckan öppnades under receptet",
    "equipment.DOOR CLOSED RECIPE": "Luckan stängdes under receptet",
    "equipment.Receitas iniciadas": "Startade recept",
    "equipment.Receitas concluídas": "Slutförda recept",
    "equipment.Receitas interrompidas": "Avbrutna recept",
    "equipment.Total de receitas concluídas:": "Totalt antal slutförda recept:",
    "equipment.TOTAL DE RECEITAS INTERROMPIDAS": "TOTALT AVBRUTNA RECEPT",
    "equipment.DOWNLOAD_PROGRESS": "LADDAR NER FIL... VÄNTA, FÖRLOPP: {progress} %",
    "equipment.Informe o número de série do forno": "Ange ugnens serienummer",
    "equipment.preencha o número de série do forno": "Fyll i ugnens serienummer",
    "equipment.NÚMERO DE SÉRIE NÃO CADASTRADO": "SERIENUMRET ÄR INTE REGISTRERAT",
    "equipment.Número de série não encontrado. Por favor, verifique e tente novamente": "Serienumret hittades inte. Kontrollera och försök igen.",
    "equipment.Antes de iniciar a atualização, faça o backup das receitas salvas no equipamento para garantir a integridade dos dados. O backup pode ser feito via pen drive ou pela plataforma. Isso permite a recuperação das informações em caso de perda.": "Innan du startar uppdateringen ska du säkerhetskopiera recepten som är sparade på utrustningen för att säkerställa dataintegriteten. Säkerhetskopian kan göras med ett USB-minne eller via plattformen. Detta gör det möjligt att återställa informationen om den skulle gå förlorad.",
    "equipment.MENU RECEIVED FROM THE PLATFORM BY FORCED METHOD": "Meny mottagen från plattformen via tvingad uppdatering",
    "equipment.Nome da receita não encontrado": "Receptnamnet hittades inte",
    "equipment.passos": "{count, plural, one {steg} other {steg}}",
    "equipment.minAbbreviation": "Min min min min min",
    "equipment.secAbbreviation": "Sek",
    "equipment.Configurações": "Inställningar",
    "equipment.Tempo de preaquecimento": "Förvärmningstid",
    "equipment.Formato de data": "Datumformat",
    "equipment.Formato de hora": "Tidsformat",
    "equipment.Unidade de temperatura": "Temperaturenhet",
    "equipment.Aquecer/dourar mais": "Värm/bryn mer",
    "equipment.Fabricante": "Tillverkare",
    "equipment.Voltagem": "Spänning",
    "equipment.Introdução": "Introduktion",
    "equipment.Modelo": "Modell",
    "equipment.Motor": "Motormotor",
    "equipment.Hostname": "Värdnamn",
    "equipment.STATUS DA OPERAÇÃO": "DRIFTSTATUS",
    "equipment.ÚLTIMA LIMPEZA": "SENASTE RENGÖRING",
    "equipment.VELOCIDADE DO MOTOR": "MOTORHASTIGHET",
    "equipment.TENSÃO ATUAL": "AKTUELL SPÄNNING",
    "equipment.Sensores e periféricos": "Sensorer och kringutrustning",
    "equipment.Contadores": "Räknare",
    "equipment.HORAS DE USO DO MOTOR": "MOTORNS ANVÄNDNINGSTIMMAR",
    "equipment.HORAS DE USO DO MAGNETRON": "MAGNETRONENS ANVÄNDNINGSTIMMAR",
    "equipment.ABERTURAS DE PORTA": "LUCKÖPPNINGAR",
        "equipment.ATUAÇÃO DO RELE DA POWER": "POWER-RELÄETS AKTIVERING",
    "equipment.ATUAÇÃO DO SENSOR DE PORTA": "DÖRRSENSORNS AKTIVERING",
    "equipment.RECEITAS EXECUTADAS": "UTFÖRDA RECEPT",
    "equipment.LIMPEZAS EXECUTADAS": "UTFÖRDA RENGÖRINGAR",
    "equipment.HORAS DE USO DO FILTRO CATALÍTICO": "ANVÄNDNINGSTIMMAR FÖR KATALYTISKT FILTER",
    "equipment.HORAS DE USO DO FILTRO DE AR": "ANVÄNDNINGSTIMMAR FÖR LUFTFILTER",
    "equipment.CORRENTE DO MAGNETRON": "MAGNETRONSTRÖM",
    "equipment.Erros": "Fel",
    "equipment.status online": "Online online",
    "equipment.status offline": "Offline",
    "equipment.software accepted": "Programvaran",
    "equipment.menu accepted": "Meny",
    "equipment.software pending": "programvara väntar",
    "equipment.menu pending": "meny väntar",
    "equipment.software refused": "Program Nekad",
    "equipment.menu refused": "Meny nekad",
    "equipment.Ativado": "Aktiverad",
    "equipment.Desativado": "Inaktiverad",
    "equipment.Cozinhando": "Tillagar",
    "equipment.Pré-aquecendo": "Förvärmer",
    "equipment.Em espera": "Standby",
    "equipment.Limpando": "Rengör",
    "equipment.horas": "timmar",
    "equipment.Erro CAN": "CAN-Fel",
    "equipment.Erro no sensor de câmara": "Fel på kammarsensorn",
    "equipment.Alerta de temperatura alta no painel": "Varning för hög paneltemperatur",
    "equipment.Erro de temperatura alta no painel": "Fel på grund av hög paneltemperatur",
    "equipment.Alerta de comunicação no inversor de frequência": "Kommunikationsvarning för frekvensomriktaren",
    "equipment.Alerta de status no inversor de frequência": "Statusvarning för frekvensomriktaren",
    "equipment.Alerta na corrente do magnetron": "Varning för magnetronström",
    "equipment.Erro no modelo do equipamento": "Fel i Typsmodell",
    "equipment.Erro no módulo de energia": "Fel i energimodulen",
    "equipment.Erro I2C": "I2C-fel",
    "equipment.Erro de temperatura alta na placa": "Fel på grund av hög korttemperatur",
    "equipment.Fechado": "Stängd",
    "equipment.Aberto": "Öppen",
    "equipment.Câmara": "Kammare",
    "equipment.Placa": "Kretskort",
    "equipment.Tensão": "Spänning",
    "equipment.Corrente da placa": "Kortström",
    "equipment.Velocidade do motor": "Motorhastighet",
    "equipment.Rele da resistência": "Värmeelementets relä",
    "equipment.Rele de curto circuito": "Kortslutningsrelä",
    "equipment.Ventilador radial": "Radialfläkt",
    "equipment.Led vermelho": "Röd LED",
    "equipment.Led verde": "Grön LED",
    "equipment.Led azul": "Blå LED",
    "equipment.Erro": "Fel",
    "equipment.Sensor": "Sensor",
    "equipment.Valor": "Värde",
  "equipment.Manutenção da temperatura": "Temperaturhållning",
  "equipment.Manutenção": "Underhåll",
  "equipment.Esfriando": "Kyls ned",
  "equipment.CEILING SENSOR ERROR": "Fel på taksensor",
  "equipment.BALLAST SENSOR ERROR": "Fel på bottensensor",
  "equipment.VAPORIZER SENSOR ERROR": "Fel på förångarsensor",
  "equipment.EQUIPMENT CONSUMPTION": "Förbrukning",
  "equipment.Sensores": "Sensorer",
  "equipment.Falta de água": "Vattenbrist",
  "equipment.Executando Receita": "Recept körs",
  "equipment.Executando Limpeza": "Rengöring pågår",
  "equipment.Dia": "Dag Dag Dag Dag Dag",
  "equipment.Semana": "Vecka",
  "equipment.Mês": "Månad",
  "equipment.Tempo": "Tid",
  "equipment.Segunda": "Måndag",
  "equipment.Terça": "Tisdag",
  "equipment.Quarta": "Onsdag",
  "equipment.Quinta": "Torsdag",
  "equipment.Sexta": "Fredag",
  "equipment.Sábado": "Lördag",
  "equipment.Domingo": "Söndag",
  "equipment.CONSUMO ESTIMADO": "UPPSKATTAD FÖRBRUKNING",
  "equipment.CONSUMO ATUAL": "AKTUELL FÖRBRUKNING",
  "equipment.ECONOMIA COM MODO ECO": "BESPARING MED ECO-LÄGE",
  "equipment.MÉDIA SEMANAL": "VECKOMEDEL",
  "equipment.MÉDIA MENSAL": "MÅNADSMEDEL",
  "equipment.Consumo de energia": "Energiförbrukning",
  "equipment.CONSUMO ACUMULADO": "ACKUMULERAD FÖRBRUKNING",
  "equipment.MÉDIA DIÁRIA": "DAGSMEDEL",
  "equipment.mês selecionado": "vald månad",
 "equipment.Este valor representa a soma total dos consumos de cada hora do dia.": "Detta värde representerar den totala summan av energiförbrukningen för varje timme under dagen.",
  "equipment.Este valor representa a soma total dos consumos de cada dia.": "Detta värde representerar den totala summan av energiförbrukningen för varje dag.",
  "equipment.Este valor representa a soma total dos consumos de cada semana.": "Detta värde representerar den totala summan av energiförbrukningen för varje vecka.",
  "equipment.Este valor representa a soma total dos consumos de cada mês.": "Detta värde representerar den totala summan av energiförbrukningen för varje månad.",
  "equipment.Este valor representa a média do consumo das horas, apresentando assim uma estimativa baseada em seu uso.": "Detta värde representerar den genomsnittliga energiförbrukningen per timme och ger därmed en uppskattning baserad på användningen.",
  "equipment.Este valor representa a média do consumo de cada dia, apresentando assim uma estimativa baseada em seu uso.": "Detta värde representerar den genomsnittliga energiförbrukningen per dag och ger därmed en uppskattning baserad på användningen.",
  "equipment.Este valor representa a média do consumo semanal, apresentando assim uma estimativa baseada em seu uso.": "Detta värde representerar den genomsnittliga veckoförbrukningen och ger därmed en uppskattning baserad på användningen.",
  "equipment.Este valor representa a média do consumo dos últimos dois meses, apresentando assim uma estimativa baseada em seu uso.": "Detta värde representerar den genomsnittliga energiförbrukningen under de senaste två månaderna och ger därmed en uppskattning baserad på användningen.",
  "equipment.Este valor representa a soma total da economia de consumo de cada hora do dia com a utilização do modo Eco.": "Detta värde representerar den totala energibesparingen för varje timme under dagen vid användning av Eco-läget.",
  "equipment.Este valor representa a soma total da economia de consumo de cada dia com a utilização do modo Eco.": "Detta värde representerar den totala energibesparingen för varje dag vid användning av Eco-läget.",
  "equipment.Este valor representa a soma total da economia de consumo semanal com a utilização do modo Eco.": "Detta värde representerar den totala veckobesparingen av energi vid användning av Eco-läget.",
  "equipment.Este valor representa a soma total da economia de consumo mensal com a utilização do modo Eco.": "Detta värde representerar den totala månatliga energibesparingen vid användning av Eco-läget.",
  "equipment.Este valor representa a média de consumo dos últimos 7 dias, desconsiderando o dia atual.": "Detta värde representerar den genomsnittliga energiförbrukningen under de senaste sju dagarna, exklusive den aktuella dagen.",
  "equipment.Este valor representa a média de consumo das últimas 4 semanas.": "Detta värde representerar den genomsnittliga energiförbrukningen under de senaste fyra veckorna.",
  "equipment.Este valor representa a média de consumo dos últimos 2 meses, desconsiderando o mês atual.": "Detta värde representerar den genomsnittliga energiförbrukningen under de senaste två månaderna, exklusive den aktuella månaden.",
  "equipment.Lista de consumo de energia": "Lista över energiförbrukning",
  "equipment.Período": "Period",
  "equipment.Consumo (kWh)": "Förbrukning (kWh)",
  "equipment.Economia com ECO (kWh)": "Besparing med ECO (kWh)",
  "equipment.Total": "Totalt",
  "equipment.Sensor de RI": "RI-sensor",
  "equipment.HUMIDITY SENSOR ERROR": "Fel på fuktsensor",
  "equipment.TEMPERATURE SENSOR ERROR": "Fel på temperatursensor",
  "equipment.WATER FILTER CLEANING COMPLETED": "Byte av vattenfilter slutfört",
  "equipment.WATER FILTER CLEANING REJECTED": "Byte av vattenfilter avvisat",
  "equipment.HOOD TURNED ON": "Kåpa påslagen",
  "equipment.HOOD TURNED OFF": "Kåpa avstängd",
  "equipment.AUTOMATIC PREHEATING REJECTED": "Automatisk förvärmning avvisad",
  "equipment.Receitas Forno": "Ugnsrecept",
  "equipment.Receitas Fermentadora": "Jäsningsrecept",
  "equipment.média diária": "Dagligt genomsnitt",
  "equipment.média de execução diária": "genomsnittligt antal körningar per dag",
  "equipment.FERMENTADORA": "JÄSSKÅP",
  "equipment.FORNO": "UGN",
  "equipment.DIA": "DAG",
  "equipment.Baixado": "Nedladdad",
  "equipment.A limpeza diária do equipamento auxilia em seu bom funcionamento e impacta na garantia.": "Daglig rengöring av utrustningen bidrar till korrekt funktion och påverkar garantin.",
  "equipment.Desde a vinculação do equipamento ao IOK": "Sedan utrustningen kopplades till IOK",
  "equipment.Total desde a vinculação do equipamento ao IOK": "Totalt sedan utrustningen kopplades till IOK",
  "equipment.Receitas do forno": "Ugnsrecept",
  "equipment.Receitas da fermentadora": "Jässkåpsrecept",
  "equipment.FERM.": "JÄSSK.",
  "equipment.Fermentadora": "Jässkåp",
  "equipment.Coifa": "Kåpa",
  "equipment.Preaquecimento automático": "Automatisk förvärmning",
  "equipment.nivel": "nivå",
  "equipment.Fermentadora ligada": "Jässkåp påslaget",
  "equipment.Fermentadora desligada": "Jässkåp avstängt",
  "equipment.Forno desligado": "Ugn avstängd",
  "equipment.Equipamento ligado": "Utrustning påslagen",
  "equipment.Equipamento desligado": "Utrustning avstängd",
  "equipment.visualizar haccp": "Visum HACCP",
  "equipment.HACCP": "HACCP",
  "equipment.Atualizar Equip.": "Uppdatera utrustning",
  "equipment.Consumo de agua por receita": "Vattenförbrukning per recept",
  "equipment.Consumo de energia por receita": "Energiförbrukning per recept",
  "equipment.AINDA NAO HA DADOS DE CONSUMO DE AGUA POR RECEITA :(": "DET FINNS ÄNNU INGA DATA OM VATTENFÖRBRUKNING PER RECEPT :(",
  "equipment.AINDA NAO HA DADOS DE CONSUMO DE ENERGIA POR RECEITA :(": "DET FINNS ÄNNU INGA DATA OM ENERGIFÖRBRUKNING PER RECEPT :(",
  "equipment.LITROS CONSUMIDOS NO DIA": "LITER FÖRBRUKADE UNDER DAGEN",
  "equipment.ENERGIA CONSUMIDA NO DIA": "ENERGI FÖRBRUKAD UNDER DAGEN",
  "equipment.CONSUMO ACUMULADO SEMANAL": "ACKUMULERAD VECKOFÖRBRUKNING",
  "equipment.CONSUMO ACUMULADO MENSAL": "ACKUMULERAD MÅNADSFÖRBRUKNING",
  "equipment.Receitas": "Recept",
  "equipment.Consumo (L)": "Förbrukning (L)",
  "equipment.Exec. dia - (L)": "Körningar dag - (L)",
  "equipment.Exec. semana - (L)": "Körningar vecka - (L)",
  "equipment.Exec. mês - (L)": "Körningar månad - (L)",
  "equipment.Exec. dia - (kWh)": "Körningar dag - (kWh)",
  "equipment.Exec. semana - (kWh)": "Körningar vecka - (kWh)",
  "equipment.Exec. mês - (kWh)": "Körningar månad - (kWh)",
  "equipment.Agua consumida (litros)": "Förbrukat vatten (liter)",
  "equipment.Energia consumida (kWh)": "Förbrukad energi (kWh)",
  "equipment.temperatura da câmara": "Kammartemperatur",
  "equipment.temperatura do vapor": "Ångtemperatur",
  "equipment.último evento listado": "Senaste listade händelse",
  "equipment.temperatura da sonda": "Givartemperatur",
  "equipment.porta": "Lucka",
  "equipment.temperatura": "Temperatur",
  "equipment.temperatura atual": "Aktuell temperatur",
  "equipment.média de oscilação diária": "Genomsnittlig daglig temperaturvariation",
  "equipment.oscilação diária da temperatura": "Daglig temperaturvariation",
  "equipment.temperature.sectionTitle": "Temperatur",
  "equipment.temperature.currentChamber": "AKTUELL KAMMARTEMPERATUR:",
  "equipment.temperature.currentProbe": "AKTUELL GIVARTEMPERATUR:",
  "equipment.temperature.currentSteam": "AKTUELL ÅNGTEMPERATUR:",
  "equipment.temperature.dailyOscillation": "Daglig temperaturvariation",
  "equipment.temperature.chamberShort": "Kammare",
  "equipment.temperature.probeShort": "Givare",
  "equipment.temperature.axisLabel": "Temperatur {unit}",
  "equipment.temperature.dailyAverage": "DAGLIGT MEDELVÄRDE",
  "equipment.temperature.weeklyAverage": "VECKOMEDELVÄRDE",
  "equipment.temperature.monthlyAverage": "MÅNADSMEDELVÄRDE",
  "equipment.temperature.lastListedEvent": "Senaste registrerade händelse",
  "equipment.temperature.door": "Lucka",
  "equipment.temperature.open": "ÖPPEN",
  "equipment.temperature.closed": "STÄNGD",
  "equipment.temperature.defineTimeRange": "Ange tidsintervall:",
  "equipment.temperature.until": "till",
  "equipment.cleaningType.smart": "Smart rengöring",
  "equipment.cleaningType.light": "Lätt rengöring",
  "equipment.cleaningType.medium": "Medelrengöring",
  "equipment.cleaningType.heavy": "Kraftig rengöring",
  "equipment.cleaningType.decalcifying": "Avkalkningsrengöring",
  "equipment.cleaningType.security": "Säkerhetsrengöring",
  "equipment.cleaningType.rinse": "Sköljning",
  "equipment.cleaningType.custom": "Anpassad rengöring",
  "equipment.cleaningTypeShort.smart": "Smart Smart",
  "equipment.cleaningTypeShort.light": "Lätt",
  "equipment.cleaningTypeShort.medium": "Medel",
  "equipment.cleaningTypeShort.heavy": "Kraftig",
  "equipment.cleaningTypeShort.decalcifying": "Avkalkning",
  "equipment.cleaningTypeShort.security": "Säkerhet",
  "equipment.cleaningTypeShort.rinse": "Sköljning",
  "equipment.cleaningTypeShort.custom": "Anpassad",
  "equipment.gerar gráficos": "Generellt diagram",
  "equipment.Realizada": "Utförd",
  "equipment.Recomendada": "Rekomm.",
  "equipment.Dias da semana": "Veckodagar",
  "equipment.Horário 24h": "24-timmarsformat",
  "equipment.seg": "Mån",
  "equipment.ter": "Tis",
  "equipment.qua": "Ons",
  "equipment.qui": "Tor Tor Tor Tor",
  "equipment.sex": "Fre",
  "equipment.sab": "Lör",
  "equipment.dom": "Sön",
  "equipment.Desconhecido": "Okänd",
  "equipment.AINDA NÃO HÁ DADOS DE CONSUMO DE ENERGIA AQUI :(": "DET FINNS ÄNNU INGA DATA OM ENERGIFÖRBRUKNING HÄR :(",
  "equipment.monthShort.Jan": "Jan Jan Jan Jan Jan Jan Jan",
  "equipment.monthShort.Fev": "Feb",
  "equipment.monthShort.Mar": "Mar Mar Mar Mar Mar",
  "equipment.monthShort.Abr": "Apr",
  "equipment.monthShort.Mai": "Maj",
  "equipment.monthShort.Jun": "Jun",
  "equipment.monthShort.Jul": "Jul",
  "equipment.monthShort.Ago": "Aug",
  "equipment.monthShort.Set": "Sep",
  "equipment.monthShort.Out": "Okt",
  "equipment.monthShort.Nov": "Nov",
  "equipment.monthShort.Dez": "Dec",
  "equipment.settingsChange.category": "Parameterändring",
  "equipment.settingsChange.factoryTitle": "Ändring av teknisk parameter",
  "equipment.settingsChange.userTitle": "Ändring av användarparameter",
  "equipment.settingsChange.changedTo": "{label} ändrades till {value}",
  "equipment.settingsChange.hardResetExecuted": "Hard reset utförd",
  "equipment.settingsChange.userFactoryResetExecuted": "Användarens fabriksåterställning utförd",
  "equipment.settingsChange.magSensorEnabled": "magnetronsensor",
  "equipment.settingsChange.serialNumber": "Serienummer",
  "equipment.settingsChange.manufactureDate": "Försdatum",
  "equipment.settingsChange.inverterType": "typ av frekvensomriktare",
  "equipment.settingsChange.preHeatMotorSpeed": "motorhastighet för förvärmning",
  "equipment.settingsChange.voltage": "spänning",
  "equipment.settingsChange.oemModeEnabled": "OEM-läge",
  "equipment.settingsChange.controlDoor": "dörrstyrning",
  "equipment.settingsChange.hardReset": "Hård återställning",
  "equipment.settingsChange.preHeatTemperatureOne": "förvärmningstemperatur 1",
  "equipment.settingsChange.preHeatTemperatureTwo": "förvärmningstemperatur 2",
  "equipment.settingsChange.preHeatTime": "förvärmningstid",
  "equipment.settingsChange.preHeatTwoEnabled": "förvärmning 2",
  "equipment.settingsChange.userFactoryReset": "Användarens fabriksåterställning",
  "equipment.settingsChange.enableManualMode": "manuellt läge",
  "equipment.settingsChange.enableFavorites": "Favoriter",
  "equipment.settingsChange.enableHeatBrown": "värm/bryn mer",
  "equipment.settingsChange.enableRepeatRecipe": "Recept",
  "equipment.settingsChange.enableOperatorMode": "operatörsläge",
  "equipment.settingsChange.enableAutoImport": "automatisk import",
  "equipment.settingsChange.enableRecipePreRunMessage": "meddelande före receptstart",
  "equipment.settingsChange.controlDoorTwoInputs": "2 ingångar",
  "equipment.settingsChange.controlDoorThreeInputs": "3 ingångar",

  //LOJAS
  "store.Procurar loja": "Sök butik",
  "store.Excluir": "Ta bort",
  "store.Editar": "Redigera",
  "store.nome": "Namn",
  "store.equipamentos": "Utrustningar",
  "store.cidade": "Stad",
  "store.estado": "Delstat",
  "store.salvar": "Spara",
  "store.cadastrar loja": "Registerbutik",
  "store.Nome fantasia": "Butiksnamn",
  "store.Preencha o nome da loja": "Fyll i butikens namn",
  "store.CNPJ": "CNPJ",
  "store.Preencha o CNPJ da loja": "Fyll i butiker CNPJ",
  "store.CEP": "Postnummer",
  "store.Preencha o CEP da loja": "Fyll i butikens postnummer",
  "store.Informe o nome fantasia": "Ange butiksnamnet",
  "store.Cidade": "Stad",
  "store.Informe a cidade": "Ange Stad",
  "store.Preencha a cidade": "Fyll i stad",
  "store.UF": "Delstat",
  "store.Preencha o UF da loja": "Fyll i butikens delstat",
  "store.Bairro": "Stadsdel",
  "store.Informe o bairro": "Ålder stadsdel",
  "store.Preencha o bairro da loja": "Fyll i butikens stadsdel",
  "store.Endereço": "Adress",
  "store.Informe o endereço": "Ange Adress",
  "store.Preencha o endereço da loja": "Fyll i butikens adress",
  "store.Nº": "Nr",
  "store.Preencha o número": "Fyll i nummer",
  "store.Loja cadastrada com sucesso": "Butiken har registrerats",
  "store.Erro ao adicionar loja. Tente novamente": "Det gick inte att lägga till butiken. Försök igen",
  "store.Loja deletada com sucesso": "Butiken har tagits bort",
  "store.Erro ao deletar loja. Tente novamente mais tarde": "Det gick inte att ta bort butiken. Försök igen senare",
  "store.AINDA NÃO HÁ NENHUMA LOJA CADASTRADA :(": "DET FINNS ÄNNU INGA REGISTRERADE BUTIKER :(",
  "store.EXCLUIR LOJA": "TA BUTIK BORT",
  "store.Você deseja excluir a loja da plataforma IOK?": "Vill du ta bort butiken från IOK-plattformen?",
  "store.Ao fazer isso, os equipamentos atrelados à ela não terão vínculo com nenhuma loja, a menos que os vincule novamente.": "Om du gör detta kommer utrustningarna som är kopplade till butiken inte längre att vara kopplade till någon butik, om du inte kopplar dem igen.",
  "store.loja editada com sucesso": "Butiken har uppdaterats",
  "store.não foi possível editar a loja. Tente novamente mais tarde": "Det gick inte att redigera butiken. Försök igen senare",
  "store.editar loja": "Redigera butik",
  "store.Procurar grupo de equipamentos": "Sök utrustningsgrupp",
  "store.cadastrar grupo": "Registrera grupp",
  "store.AINDA NÃO HÁ NENHUM GRUPO CADASTRADO :(": "DET FINNS ÄNNU INGA REGISTRERADE GRUPPER :(",
  "store.description.AINDA NÃO HÁ NENHUM GRUPO CADASTRADO :(": "Klicka på knappen längst upp till höger för att lägga till grupper.",
  "store.cadastrar grupo de equipamentos": "Registreringsgrupp",
  "store.grupo de equipamentos cadastrado com sucesso!": "Utrustningsgruppen har registrerats!",
  "store.não foi possível cadastrar o grupo. Tente novamente mais tarde": "Det gick inte att registrera gruppen. Försök igen senare",
  "store.Nome do grupo": "Gruppnamn",
  "store.informe o nome do grupo": "Åldersgruppnamnet",
  "store.preencha o nome do grupo": "Fyll i gruppnamnet",
  "store.Grupo de equipamentos deletado com sucesso!": "Utrustningsgruppen har tagits bort!",
  "store.Erro ao deletar o grupo. Tente novamente mais tarde": "Det gick inte att ta bort gruppen. Försök igen senare",
  "store.EXCLUIR GRUPO DE EQUIPAMENTOS": "TA BORT UTRUSTNINGSGRUPP",
  "store.Você deseja excluir este grupo de equipamentos da plataforma IOK?": "Vill du ta bort denna utrustningsgrupp från IOK-plattformen?",
  "store.Ao fazer isso, os equipamentos atrelados à ele não terão vínculo com nenhum grupo, a menos que os vincule novamente.": "Om du gör detta kommer utrustningarna som är kopplade till gruppen inte längre att vara kopplade till någon grupp, om du inte kopplar dem igen.",
  "store.grupo de equipamentos editado com sucesso!": "Utrustningsgruppen har uppdaterats!",
  "store.não foi possível editar o grupo. Tente novamente mais tarde": "Det gick inte att redigera gruppen. Försök igen senare",
  "store.editar grupo de equipamentos": "redigera typesgrupp",
  "store.CEP não encontrado no Brasil": "Postnumret hittades inte i Brasilien",

  // NAVBAR
  "navbar.home": "Hem",
  "navbar.cookbook": "Kockbok",
  "navbar.my menus": "Mina menyer",
  "navbar.equipment": "Typar",
  "navbar.users": "användare",
  "navbar.calls": "serviceärenden",
  "navbar.settings": "inställningar",
  "navbar.help": "hjälp",
  "navbar.logout": "Logga ut",
  "navbar.Editar conta": "Redigera-konto",
  "navbar.API Externa": "Externt API",
  "navbar.companhias": "företag",
  "navbar.information": "IOK-information",

  // FOOTERBAR
  "footerBar.menu": "Meny",
  "footerBar.cookbook": "Cookbook",
  "footerBar.home": "Hemsidan",
  "footerBar.menus": "Menyer",
  "footerBar.notifications": "Aviseringar",

  //ATENDIMENTOS
  "calls.ATENDIMENTOS EM ABERTO": "ÖPPNA SERVICEÄRENDEN",
  "calls.ATENDIMENTOS ENCERRADOS": "AVSLUTADE SERVICEÄRENDEN",

  //MAP
  "map.título": "Platser",
  "map.erro": "Föll!",
  "map.mensagem de erro": "det gick inte att ladda kartan.",
  "map.Localização não disponível": "Plats ej tillgänglig",

  //MODAL
  "modal.CONFIRMAR": "BEKRÄFTA",
  "modal.Salvar alterações": "Spara ändringar",
  "Modal.Há alterações não salvas nos parâmetros dos passos ": "Det finns osparade ändringar i stegens parametrar ",
  "Modal.Como deseja proceder?": "Hur vill du gå vidare?",
  "Modal.Avaliar alterações realizadas": "Granska gjorda ändringar",
  "Modal.Descartar alterações": "Ignorera ändringar",

  //USUÁRIOS
  "user.Nome": "Namn",
  "user.E-mail": "E-post",
  "user.Permissão": "Behörighet",
  "user.Loja": "Butik",
  "user.Status": "Status",
  "user.Excluir": "Ta bort",
  "user.Editar": "Redigera",
  "user.Procurar usuário": "Sök användare",
  "user.ADICIONAR USUÁRIO": "LÄGG TILL ANVÄNDARE",
  "user.AINDA NÃO HÁ NENHUM USUÁRIO CADASTRADO :(": "DET FINNS ÄNNU INGA REGISTRERADE ANVÄNDARE :(",
  "user.+ Usuário": "+ Användare",
  "user.Informe o nome do usuário": "Ange användarens namn",
  "user.Preencha o nome do usuário": "Fyll i användarens namn",
  "user.Informe o e-mail do usuário": "Ange användarens e-postadress",
  "user.Preencha com um e-mail válido": "Ange en giltig e-postadress",
  "user.Administrador": "Administratör",
  "user.Usuário": "Användare",
  "user.Preencha o telefone do usuário": "Fyll i användarens telefonnummer",
  "user.Selecione a permissão do usuário": "Välj användarens behörighet",
  "user.Ativo": "Aktiv",
  "user.Inativo": "Inaktiv",
  "user.Usuário deletado da plataforma com sucesso!": "Användaren har tagits bort från plattformen!",
  "user.Ocorreu um erro. Tente novamente mais tarde": "Ett fel uppstod. Försök igen senare",
  "user.EXCLUIR USUÁRIO": "TA BORT ANVÄNDARE",
  "user.delete.paragrafo 1": "Vill du ta bort användaren från IOK-plattformen?",
  "user.delete.paragrafo 2": "Om du gör detta kommer användaren att förlora åtkomsten till alla plattformens funktioner, om den inte läggs till igen enligt registreringsanvisningarna.",
  "user.EDITAR USUÁRIO": "REDIGERA ANVÄNDARE",
  "user.Usuário editado com sucesso!": "Användaren har uppdaterats!",
  "user.Não foi possível editar este usuário. Por favor, tente mais tarde": "Det gick inte att redigera denna användare. Försök igen senare",
  "user.INFORMAÇÕES DO USUÁRIO": "ANVÄNDARINFORMATION",
  "user.Telefone": "Telefon",
  "user.Não foi possível cadastrar este usuário. Por favor, tente mais tarde": "Det gick inte att registrera denna användare. Försök igen senare",
  "user.Usuário adicionado com sucesso!": "Användaren har lagts till!",
  "user.CRIAR TIPO DE USUÁRIO": "SKAPA ANVÄNDARTYP",
  "user.Criar novo tipo de usuário": "Skapa ny användartyp",
  "user.Adicionar novo usuário": "Lägg till ny användare",
  "user.Permissões": "Behörigheter",
  "user.Preencha o nome do novo tipo de usuário": "Fyll i namnet på den nya användartypen",
  "user.Selecione pelo menos uma permissão": "Välj minst en behörighet",
  "user.Não foi possível carregar as permissões": "Det gick inte att läsa in behörigheterna",
  "user.Tipo de usuário criado com sucesso!": "Användartypen har skapats!",
  "user.Não foi possível criar este novo tipo de usuário. Por favor, tente mais tarde": "Det gick inte att skapa denna användartyp. Försök igen senare",
  "user.Não foi possível carregar os tipos de usuário da companhia": "Det gick inte att läsa in företagets användartyper",
  "user.Tipo de usuário": "Användartyp",
  "user.E-mail já cadastrado na plataforma. Informe um novo e-mail": "E-postadressen är redan registrerad på plattformen. Ange en annan e-postadress",
  "user.UNIR CONTAS": "SAMMANFOGA-KONTON",
  "user.ID da companhia": "Företags-ID",
  "user.Digite o ID da companhia que deseja unir a sua conta": "Ange ID för det företag vars konto du vill sammanfoga med ditt",
  "user.Preencha o ID da companhia": "Fyll i företags-ID",
  "user.O administrador da outra conta poderá localizar o ID ao clicar em seu nome de usuário, localizado no menu superior, no canto direito da tela.": "Administratören för det andra kontot hittar ID:t genom att klicka på sitt användarnamn i den övre menyn, längst upp till höger på skärmen.",
  "user.O administrador da outra conta receberá um e-mail para aceitar sua solicitação. Assim que for aceita, a união das duas contas será realizada!": "Administratören för det andra kontot får ett e-postmeddelande för att godkänna din begäran. Så snart den godkänns kommer de två kontona att sammanfogas!",
  "user.Não foi possível solicitar a união de contas. Por favor, confirme o ID ou tente mais tarde": "Det gick inte att begära sammanfogning av kontona. Kontrollera ID:t eller försök igen senare",
  "user.SOLICITAÇÃO APROVADA COM SUCESSO": "BEGÄRAN GODKÄND",
  "user.AGUARDE ENQUANTO REALIZAMOS A UNIÃO DAS CONTAS. ESTE PROCESSO PODE LEVAR ALGUNS MINUTOS...": "VÄNTA MEDAN VI SAMMANFOGAR KONTONA. DETTA KAN TA NÅGRA MINUTER...",
  "user.UNIÃO DE CONTAS FINALIZADA COM SUCESSO! CLIQUE NO BOTÃO ABAIXO PARA ACESSAR A PLATAFORMA.": "SAMMANFOGNINGEN AV KONTONA HAR SLUTFÖRTS! KLICKA PÅ KNAPPEN NEDAN FÖR ATT ÖPPNA PLATTFORMEN.",
  "user.NÃO CONSEGUIMOS REALIZAR A UNIÃO DAS CONTAS. POR FAVOR, TENTE NOVAMENTE. SE O PROBLEMA PERSISTIR, ENTRE EM CONTATO COM VÅR SUPPORT.": "VI KUNDE INTE SAMMANFOGA KONTONA. FÖRSÖK IGEN. OM PROBLEMET KVARSTÅR, KONTAKTA VÅR SUPPORT.",
  "user.possui todos os acessos": "har alla behörigheter",
"user.possui o acesso das abas cookbook, meus menus e equipamentos": "har åtkomst till flikarna Cookbook, Mina menyer och Utrustningar",
  "user.possui apenas o acesso da aba cookbook": "har endast åtkomst till fliken Cookbook",
  "user.possui apenas o acesso da aba equipamentos": "har endast åtkomst till fliken Utrustningar",
  "user.possui apenas o acesso da aba meus menus": "har endast åtkomst till fliken Mina menyer",
  "user.Grupo de equipamentos": "Utrustningsgrupp",
  "user.Informe o telefone do usuário": "Ange användarens telefonnummer",
  "user.Nenhum grupo criado": "Ingen grupp har skapats",
  "user.Digite o ID da companhia que terá acesso à sua conta": "Ange ID:t för det företag som ska få åtkomst till ditt konto",
  "user.Ao informar um ID para unir contas com sua companhia, esteja ciente de que o novo usuário também se tornará Administrador da conta de sua companhia. É importante informar que a partir do momento em que um usuário aceitar unir contas com sua companhia, a companhia pertencente a ele deixará de existir.": "När du anger ett ID för att sammanfoga konton med ditt företag ska du vara medveten om att den nya användaren också blir administratör för företagets konto. Observera att från och med det att en användare accepterar att sammanfoga sitt konto med ditt företag kommer användarens ursprungliga företag att upphöra att existera.",
  "user.Exemplo: Sua conta: 001 | Outra conta: 111. Depois de unir contas com você, a outra conta passará a ser 001.": "Exempel: Ditt konto: 001 | Annat konto: 111. Efter sammanfogningen blir det andra kontot 001.",
  "user.Tela de Equipamentos": "Utrustningssidan",
  "user.Tela de Meus Menus": "Sidan Mina menyer",
  "user.Tela do Cookbook": "Cookbook-sidan",
  "user.Tela de Usuários": "Användarsidan",
  "user.Aba de Suporte": "Supportfliken",
  "user.Usuário Comum": "Standardanvändare",
  "user.Usuário do Cookbook": "Cookbook-användare",
  "user.Usuário de Equipamentos": "Utrustningsanvändare",
  "user.Usuário de Meus Menus": "Användare av Mina menyer",
  "user.Você deseja excluir seu acesso da plataforma IOK?": "Vill du ta bort din åtkomst till IOK-plattformen?",
  "user.Ao fazer isso, você perderá o acesso a todas as ferramentas da plataforma e, para voltar a acessá-la, será necessário ser adicionado à ela novamente.": "Om du gör detta förlorar du åtkomsten till alla plattformens funktioner. För att få åtkomst igen måste du läggas till på nytt.",
  "user.CONFIRMAÇÃO": "BEKRÄFTELSE",
  "user.Confirme sua senha": "Bekräfta ditt lösenord",
  "user.Senha incorreta": "Felaktigt lösenord",
  "user.Os equipamentos e menus criados por ele serão transferidos para o seu nome.": "Utrustningarna och menyerna som skapats av användaren kommer att överföras till ditt namn.",

  //TUTORIAIS
  "tutorial.Fechar": "Stäng",
  "tutorial.Fim": "Slutför",
  "tutorial.Próximo": "Nästa",
  "tutorial.Abrir": "Öppna",
  "tutorial.Pular tutorial": "Hoppa över handledningen",
  "tutorial.Editar detalhes da receita": "Redigera receptinformation",
  "tutorial.Agora você pode adicionar mais detalhes às suas receitas e deixá-las ainda mais completas. Clique em Editar detalhes e preencha as informações necessárias.": "Nu kan du lägga till mer information i dina recept och göra dem ännu mer kompletta. Klicka på Redigera information och fyll i de nödvändiga uppgifterna.",
  "tutorial.Salvar edição da receita": "Spara receptändringar",
  "tutorial.Depois de informar mais detalhes da receita, clique em Salvar.": "När du har lagt till mer information om receptet klickar du på Spara.",
  "tutorial.Editar registro de um equipamento": "Redigera en utrustningsregistrering",
  "tutorial.Para completar o registro de seus equipamentos, abra o sidomenyn, clique em Editar e preencha as informações de Categoria e Loja.": "För att slutföra registreringen av dina utrustningar öppnar du sidomenyn, klickar på Redigera och fyller i informationen om kategori och butik.",
  "tutorial.Editar usuário": "Redigera användare",
  "tutorial.Para completar o cadastro dos usuários, abra o menu lateral, clique em Editar e preencha a informação referente a Loja a qual ele faz parte.": "För att slutföra registreringen av användarna öppnar du sidomenyn, klickar på Redigera och fyller i informationen om vilken butik användaren tillhör.",
  "tutorial.Salvar edições de um equipamento": "Spara ändringar av utrustning",
  "tutorial.Depois de completar o registro de seus equipamentos, clique em Salvar.": "När du har slutfört registreringen av dina utrustningar klickar du på Spara.",
  "tutorial.Ao clicar sobre a linha de um equipamento cadastrado em uma loja, você pode visualizar mais estatísticas e informações sobre ele, além de poder solicitar um atendimento ou disparar atualizações.": "När du klickar på raden för en utrustning som är registrerad i en butik kan du se mer statistik och information om den samt begära service eller skicka uppdateringar.",
  "tutorial.Para visualizar mais informações sobre a loja, como localização e receitas mais preparadas, clique sobre a linha da unidade que deseja analisar.": "För att visa mer information om butiken, såsom plats och de recept som har tillagats flest gånger, klickar du på raden för den enhet du vill analysera.",
  "tutorial.Criar receita": "Skapa recept",
  "tutorial.No cookbook você pode criar suas próprias receitas! Clique em Criar Receita e preencha todas as informações necessárias.": "I Cookbook kan du skapa dina egna recept! Klicka på Skapa recept och fyll i all nödvändig information.",
  "tutorial.Editar ou excluir um usuário": "Redigera eller ta bort en användare",
  "tutorial.Para excluir ou editar as informações de um usuário já cadastrado, clique no menu lateral e selecione a opção desejada.": "För att ta bort eller redigera information om en redan registrerad användare öppnar du sidomenyn och väljer önskat alternativ.",
  "tutorial.Gerenciamento de usuários": "Användarhantering",
  "tutorial.Aqui você pode gerenciar seus usuários com mais facilidade. Ao clicar em + Usuário, você poderá adicionar um novo usuário ou criar um novo tipo de usuário.": "Här kan du enkelt hantera dina användare. Genom att klicka på + Användare kan du lägga till en ny användare eller skapa en ny användartyp.",
  "tutorial.Suas receitas": "Dina recept",
  "tutorial.Pelo cookbook você também encontra suas próprias receitas, além de poder criá-las! Clique em Receitas Salvas para visualizar as receitas que foram salvas do cookbook da Prática e também as criadas por você.": "I Cookbook hittar du även dina egna recept och kan dessutom skapa nya! Klicka på Sparade recept för att visa recepten som har sparats från Práticas Cookbook samt de som du själv har skapat.",
  "tutorial.Filtros do Cookbook": "Cookbook-filter",
  "tutorial.Para facilitar a navegação pelas receitas, você pode aplicar filtros a elas. Basta clicar no filtro desejado e escolher uma de suas opções.": "För att göra det enklare att hitta recept kan du använda filter. Klicka bara på önskat filter och välj ett av alternativen.",
  "tutorial.Cookbook": "Cookbook",
  "tutorial.No cookbook, em Receitas Disponíveis, você encontrará as receitas criadas pelos Chefs da Prática e poderá utilizá-las sempre que quiser.": "I Cookbook, under Tillgängliga recept, hittar du recept skapade av Práticas kockar som du kan använda när du vill.",
  "tutorial.Atualizar equipamentos": "Uppdatera Typar",
  "tutorial.Para enviar uma atualização a seus equipamentos, clique em Atualizar Equipamentos, selecione os modelos que deseja atualizar e a forma como deseja realizar essa atualização - via wi-fi ou pen drive. Depois disso, clique em Confirmar.": "För att skicka en uppdatering till dina utrustningar klickar du på Uppdatera utrustningar, väljer de modeller som ska uppdateras och hur uppdateringen ska utföras – via Wi-Fi eller USB-minne. Klicka sedan på Bekräfta.",
  "tutorial.Adicionar equipamento": "Lägg till utrustning",
  "tutorial.Para adicionar um equipamento à sua conta, clique em Adicionar Equipamento e preencha as informações do modal. Depois disso, clique em Salvar.": "För att lägga till en utrustning på ditt konto klickar du på Lägg till utrustning, fyller i uppgifterna i dialogrutan och klickar sedan på Spara.",
  "tutorial.Editar equipamento": "Redigera typ",
  "tutorial.Para desvincular um equipamento ou editar suas informações, clique no menu lateral e selecione a opção desejada.": "För att koppla bort en utrustning eller redigera dess information öppnar du sidomenyn och väljer önskat alternativ.",
  "tutorial.Seus equipamentos": "Dina Typar",
  "tutorial.Aqui você visualizará todos os equipamentos cadastrados em sua plataforma.": "Här visas alla utrustningar som är registrerade på din plattform.",
  "tutorial.Restaurar arquivos": "Återställ filer",
  "tutorial.Para restaurar um arquivo excluído ou deletá-lo permanentemente, clique no menu lateral e selecione a opção desejada.": "För att återställa en borttagen fil eller ta bort den permanent öppnar du sidomenyn och väljer önskat alternativ.",
  "tutorial.Lixeira": "Papperskorg",
  "tutorial.Os menus excluídos serão mantidos na Lixeira por 30 dias. Depois desse prazo serão excluídos permanentemente.": "Borttagna menyer sparas i papperskorgen i 30 dagar. Därefter tas de bort permanent.",
  "tutorial.Salvar edições de usuário": "Spara användarändringar",
  "tutorial.Depois de completar o cadastro dos usuários, clique em Salvar.": "När du har slutfört registreringen av användarna klickar du på Spara.",
  "tutorial.Criar menu": "Skapa meny",
  "tutorial.Para criar e personalizar um menu, clique em Criar Menu e preencha as informações necessárias no modal. Você pode editar um menu a qualquer momento.": "För att skapa och anpassa en meny klickar du på Skapa meny och fyller i den nödvändiga informationen i dialogrutan. Du kan redigera en meny när som helst.",
  "tutorial.Importar menu": "Importera meny",
  "tutorial.Para importar um menu, clique em Importar Menu e selecione o modell och version do equipamento.": "För att importera en meny klickar du på Importera meny och väljer utrustningens modell och version.",
  "tutorial.Criar grupo": "Skapa grupp",
  "tutorial.Para organizar suas receitas em grupos, clique em Criar Grupo e preencha as informações necessárias no modal.": "För att organisera dina recept i grupper klickar du på Skapa grupp och fyller i den nödvändiga informationen i dialogrutan.",
  "tutorial.Tipos de usuário": "Användartyper",
  "tutorial.Agora você também pode criar tipos de usuários com permissões específicas para atender melhor a sua organização.": "Nu kan du också skapa användartyper med specifika behörigheter för att bättre passa din organisation.",
  "tutorial.Gerenciamento de contas": "Kontohantering",
  "tutorial.Se caso outra pessoa da sua organização também migrou a conta principal da empresa, aqui você pode unir as duas contas.": "Om någon annan i din organisation också har migrerat företagets huvudkonto kan du sammanfoga de två kontona här.",
  "tutorial.Para completar o registro de seus equipamentos, abra o menu lateral, clique em Editar e preencha as informações de Grupo.": "För att slutföra registreringen av dina utrustningar öppnar du sidomenyn, klickar på Redigera och fyller i gruppinformationen.",
  "tutorial.Para completar o cadastro dos usuários, abra o menu lateral, clique em Editar e preencha a informação referente ao Grupo de equipamentos a qual ele faz parte.": "För att slutföra registreringen av användarna öppnar du sidomenyn, klickar på Redigera och fyller i information om den utrustningsgrupp som användaren tillhör.",
  "tutorial.Grupos de equipamentos": "Utrustningsgrupper",
  "tutorial.Na aba Grupos você pode visualizar os grupos cadastrados e os equipamentos distribuídos entre eles. Além disso, é possível cadastrar novos grupos e editar os já cadastrados.": "På fliken Grupper kan du se de registrerade grupperna och utrustningarna som är fördelade mellan dem. Du kan även skapa nya grupper och redigera befintliga.",
  "tutorial.Detalhes de grupos": "Gruppinformation",
  "tutorial.Para visualizar mais informações sobre o grupo, como localização e receitas mais preparadas, clique sobre a linha que deseja analisar.": "För att visa mer information om gruppen, såsom plats och de recept som har tillagats flest gånger, klickar du på raden för den grupp du vill analysera.",
  "tutorial.Equipamentos em grupos": "Utrustningar i grupper",
  "tutorial.Ao clicar sobre a linha de um equipamento cadastrado em um grupo, você pode visualizar mais estatísticas e informações sobre ele, além de poder solicitar um atendimento ou disparar atualizações.": "När du klickar på raden för en utrustning som är registrerad i en grupp kan du se mer statistik och information om den samt begära service eller skicka uppdateringar.",
  "tutorial.Grupos": "Grupper",
  "tutorial.Atualização e cache": "Uppdatering och cache",
  "tutorial.Para atualizar a plataforma e corrigir eventuais problemas de cache, clique aqui.": "Klicka här för att uppdatera plattformen och åtgärda eventuella cacheproblem.",
  "tutorial.Dados dos equipamentos": "Utrustningsdata",
  "tutorial.Ao clicar sobre a linha de um equipamento, você pode visualizar mais estatísticas e informações sobre ele, como as receitas mais preparadas, limpezas realizadas e outros dados relevantes.": "När du klickar på raden för en utrustning kan du se mer statistik och information om den, såsom de recept som har tillagats flest gånger, utförda rengöringar och annan relevant information.",
  "tutorial.Para alterar o idioma de sua plataforma, clique em Idioma e selecione a linguagem desejada.": "För att ändra plattformens språk klickar du på Språk och väljer önskat språk.",
  "tutorial.Alterar idioma": "Ändra språk",
  "tutorial.Para editar ou configurar sua conta, clique em seu nome e selecione a opção desejada.": "För att redigera eller konfigurera ditt konto klickar du på ditt namn och väljer önskat alternativ.",
  "tutorial.Editar conta": "Redigera-konto",
  "tutorial.Total de Usuários Cadastrados em sua conta.": "Totalt antal registrerade användare på ditt konto.",
  "tutorial.Home": "Hemsidan",
  "tutorial.Localização de seus equipamentos, sendo possível expandir o mapa para melhor visualização;": "Placeringen av dina utrustningar. Du kan förstora kartan för bättre översikt.",
  "tutorial.Atualizações referentes a versão dos equipamentos vinculados a sua conta;": "Uppdateringar om versionerna för de utrustningar som är kopplade till ditt konto.",
  "tutorial.Total de Receitas Cadastradas;": "Totalt registrerade recept.",
  "tutorial.Menus Disponíveis;": "Tillgängliga menyer.",
  "tutorial.Esta é a sua home! Aqui você encontra um resumo geral sobre sua conta;": "Det här är din startsida! Här hittar du en översikt över ditt konto.",
  "tutorial.Clique nas abas do menu para explorar a plataforma e conhecer tudo o que ela pode oferecer.": "Klicka på menyflikarna för att utforska plattformen och upptäcka allt den har att erbjuda.",
  "tutorial.Exportar menu": "Exportera meny",
  "tutorial.Depois de personalizar seu menu, exporte-o para seus equipamentos pela internet ou via USB-minne.": "När du har anpassat din meny exporterar du den till dina utrustningar via internet eller USB-minne.",
  "tutorial.Na aba Localização você pode visualizar os endereços já cadastrados, além de criar localizações precisas para vincular seus equipamentos a elas.": "På fliken Plats kan du se de adresser som redan har registrerats och skapa exakta platser för att koppla dina utrustningar till dem.",
  "tutorial.Localização": "Platser",
  "tutorial.Informações sobre o equipamento": "Information om Utrustning",
  "tutorial.Equipamentos Ligados e quantos estão enviando dados de uso;": "Utrustningar som är påslagna och hur många som skickar användningsdata;",

  "//RECOVER ACCOUNT": "",

  "recoverAccount.Para prosseguir, selecione a categoria na qual você se encaixa:": "För att fortsätta, välj den kategori som passar dig:",
  "recoverAccount.Deseja acessar a plataforma como DISTRIBUIDOR? Crie sua konto clicando em EMPRESA e entre em contato conosco para liberarmos os demais acessos.": "Vill du använda plattformen som DISTRIBUTÖR? Skapa ett konto genom att klicka på FÖRETAG och kontakta oss så aktiverar vi övriga behörigheter.",
  "recoverAccount.A qual organização você pertence": "Vilken organisation tillhör du?",

  "//RECOVER PASSWORD PAGE": "",

  "recoverPassword.E-mail para recuperação de senha": "E-post för återställning av lösenord",
  "recoverPassword.Informe o e-mail cadastrado na plataforma": "Ange den e-postadress som är registrerad på plattformen",
  "recoverPassword.E-mail inválido. Por favor, verifique": "Ogiltig e-postadress. Kontrollera och försök igen.",
  "recoverPassword.RECUPERAR SENHA": "ÅTERSTÄLL LÖSENORD",
  "recoverPassword.EM BREVE VOCÊ RECEBERÁ UM E-MAIL COM O LINK DE RECUPERAÇÃO DE SENHA": "DU KOMMER SNART ATT FÅ ETT E-POSTMEDDELANDE MED EN LÄNK FÖR ATT ÅTERSTÄLLA DITT LÖSENORD",
  "recoverPassword.Informe seu e-mail": "Ålder din e-",
  "recoverPassword.Crie uma nova senha": "Skapa ett nytt lösenord",
  "recoverPassword.O campo senha deve conter no mínimo 6 caracteres": "Lösenordet måste innehålla minst 6 tecken",
  "recoverPassword.Confirme sua senha": "Bekräfta ditt lösenord",
  "recoverPassword.As senhas devem ser iguais": "Lösenorden måste vara identiska",
  "recoverPassword.ENTRAR": "LOGGA IN",
  "recoverPassword.EM BREVE VOCÊ RECEBERÁ UM E-MAIL PARA CONFIRMAR SUA IDENTIDADE": "DU KOMMER SNART ATT FÅ ETT E-POSTMEDDELANDE FÖR ATT BEKRÄFTA DIN IDENTITET",
  "recoverPassword.CONTINUAR": "FORTSÄTT",
  "recoverPassword.CONFIRMAR": "BEKRÄFTA",
  "recoverPassword.Por segurança, o acesso à conta foi bloqueado devido a tentativas de login incorretas.": "Av säkerhetsskäl har åtkomsten till ditt konto blockerats på grund av felaktiga inloggningsförsök.",
  "recoverPassword.Para desbloquear sua conta, siga as instruções após clicar no botão abaixo:": "För att låsa upp ditt konto följer du instruktionerna efter att du har klickat på knappen nedan:",
  "recoverPassword.Desbloquear conta": "Lås upp konto",
  "recoverPassword.Você recebeu um e-mail para iniciar o desbloqueio de sua conta.": "Du har fått ett e-postmeddelande för att påbörja upplåsningen av ditt konto.",
  "recoverPassword.Verifique sua caixa de entrada ou spam.": "Kontrollera din inkorg eller skräppost.",
  "recoverPassword.Verifique seu e-mail": "Kontrollera din e-post",
  "recoverPassword.Informe seu e-mail de login e crie uma nova senha para acessar sua conta.": "Ange din e-postadress för inloggning och skapa ett nytt lösenord för att få åtkomst till ditt konto.",

  "// EXPORT": "",

  "export.Limpezas": "Rengöringar",
  "export.Eventos": "Händelser",
  "export.Lista de receitas preparadas": "Lista över förberedda recept",
  "export.Lista de limpezas realizadas": "Lista över utförda rengöringar",
  "export.Lista de eventos ocorridos": "Lista över inträffade händelser",
  "export.Exportar dados": "Exportera data",
  "export.Exportar": "Exportera",
  "export.Informações do equipamento": "Information om Utrustning",
  "export.Dados exportados com sucesso!": "Dataexporterade!",
  "export.Não foi possível exportar os dados. Por favor, tente novamente mais tarde.": "Det gick inte att exportera data. Försök igen senare.",
  "export.Detalhes do menu": "Menyinformation",
  "export.Detalhes de receitas": "Receptinformation",
  "export.Detalhes e Passos": "Information och steg",
  "export.Exportando dados. Em breve o arquivo estará disponível!": "Exporterar data. Filen kommer snart att vara tillgänglig!",
  "export.Resumo dos passos": "Stegsamman",
  "export.salvar imagem": "Spara bild",
  "export.Nenhum modelo foi selecionado": "Ingen modell har valts",

  "// COMPANIES PAGE": "",

  "company.Procurar companhia": "Sök företag",
  "company.Adicionar companhia": "Lägg till företag",
  "company.AINDA NÃO HÁ COMPANHIAS CADASTRADAS :(": "DET FINNS ÄNNU INGA REGISTRERADE FÖRETAG :(",
  "company.description.AINDA NÃO HÁ COMPANHIAS CADASTRADAS :(": "Klicka på knappen uppe till höger för att lägga till företag.",
  "company.Adicionar": "Lägg till",
  "company.ADICIONAR EQUIPAMENTOS": "LÄGG TILL UTRUSTNINGAR",
  "company.Preencha pelo menos um número de série": "Ange minst ett serienummer",
  "company.Informe os números de série": "Ange serienumren",
  "company.Número de série": "Serienummer",
  "company.Para incluir vários equipamentos, separe-os com ponto e vírgula (;).": "För att lägga till flera utrustningar, separera serienumren med semikolon (;).",
  "company.Informe o número de série do equipamento que deseja adicionar abaixo.": "Ange serienumret för den utrustning du vill lägga till nedan.",
  "company.Números de série adicionados com sucesso!": "Serienumren har lagts till!",
  "company.Não foi possível adicionar os números de série. Tente novamente mais tarde": "Det gick inte att lägga till serienumren. Försök igen senare.",
  "company.adicionar": "lägg till",
  "company.Procurar por companhia ou ID": "Sök efter företag eller ID",
  "company.Companhia": "Företag",
  "company.E-mail principal": "Primär e-postadress",
  "company.Local": "Platser",
  "company.Companhia adicionada com sucesso!": "Företaget har lagts till!",
  "company.Não foi possível cadastrar a companhia": "Det gick inte att registrera företaget",
  "company.REMOVER COMPANHIA": "TA BORT FÖRETAG",
  "company.Você deseja remover a companhia definitivamente? Os equipamentos vinculados a ela também serão removidos de sua conta.": "Vill du ta bort företaget permanent? De utrustningar som är kopplade till det kommer också att tas bort från ditt konto.",
  "company.Esta ação não poderá ser desfeita.": "Den här åtgärden kan inte ångras.",
  "company.A companhia foi removida com sucesso!": "Företaget har tagits bort!",
  "company.Não foi possível remover a companhia": "Det gick inte att ta bort företaget",
  "company.Quant. de fornos": "Antal ugnar",
  "company.Fornos conectados": "Anslutna ugnar",
  "company.Fornos não conectados": "Ej anslutna ugnar",
  "company.AINDA NÃO HÁ EQUIPAMENTOS CADASTRADOS :(": "DET FINNS ÄNNU INGA REGISTRERADE UTRUSTNINGAR :(",
  "company.description.AINDA NÃO HÁ EQUIPAMENTOS CADASTRADOS :(": "Klicka på knappen uppe till höger för att lägga till utrustningar.",
  "company.Procurar número de série": "Sök serienummer",
  "company.excluir equipamento": "Ta bort Typ",
  "company.Você deseja excluir o equipamento selecionado definitivamente?": "Vill du ta bort den valda utrustningen permanent?",
  "company.Número de série editado com sucesso!": "Serienumret har uppdaterats!",
  "company.Não foi possível editar o número de série. Tente novamente mais tarde": "Det gick inte att redigera serienumret. Försök igen senare.",
  "company.Informe o número de série": "Ange serienumret",
  "company.Preencha um número de série": "Ange ett serienummer",
  "company.EDITAR EQUIPAMENTO": "REDIGERA TYP",
  "company.Modelo": "Modell",
  "company.Cadastro": "Registrering",
  "company.Conectado": "Anfallen",
  "company.SELECIONE EQUIPAMENTOS PARA EXCLUIR": "VÄLJ UTRUSTNINGAR ATT TA BORT",
  "company.O equipamento foi removida com sucesso!": "Utrustningen har tagits bort!",
  "company.Não foi possível remover o equipamento": "Det gick inte att ta bort utrustningen",
 "company.Caracteres especiais não são permitidos, exceto o ponto e vírgula (';')": "Specialtecken är inte tillåtna, förutom semikolon (';')",
  "company.Preencha o número de série sem caracteres especiais": "Ange serienumret utan specialtecken",
  "company.Um ou mais números de série já estão provisionados para outra companhia": "Ett eller flera serienummer är redan reserverade för ett annat företag.",
  "company.Um ou mais números de série já estão conectados na conta de outra companhia": "Ett eller flera serienummer är redan anslutna till ett annat företags konto.",

  "// Error": "",

  "error.Ocorreu um erro ao carregar esta seção": "Ett fel uppstod när den här sektionen skulle läsas in",
  "error.Tentar novamente": "Försök igen",

  "// DASHBOARDS": "",

  "dashboard.fornos vinculados": "ANSLUTNA UGNAR",
  "dashboard.ativos": "Aktiva",
  "dashboard.inativos": "Inaktiva",
  "dashboard.sem status": "Ingen status",
  "dashboard.fornos atualizados": "UPPDATERADE UGNAR",
  "dashboard.com a versão do software mais recente": "Med den senaste programvaruversionen",
  "dashboard.chamados": "ÄRENDEN",
  "dashboard.veja mais no app cliente": "Se mer i kundappen",
  "dashboard.limpeza diária": "DAGLIG RENGÖRING",
  "dashboard.dos fornos estão em dia": "av ugnarna är uppdaterade",
  "dashboard.top 3": "Topp 3",
  "dashboard.média de execuções de receitas por hora": "Genomsnittligt antal receptförberedelser per timme",
  "dashboard.avisos": "MEDDELANDEN",
  "dashboard.sem avisos por aqui": "INGA MEDDELANDEN HÄR",
  "dashboard.ver mais": "Visa mer",
  "dashboard.abertos pela plataforma IOK": "Öppnade via IOK-plattformen",
  "dashboard.equipamentos": "Utrustningar",
  "dashboard.receitas": "Recept",
  "dashboard.executada": "förberedd",
  "dashboard.vezes": "gånger",
  "dashboard.forno": "Ugn",
  "dashboard.média por hora": "Genomsnitt per timme",
  "dashboard.editar": "Redigera",
  "dashboard.endereço:": "Adress:",
  "dashboard.cep:": "Postnummer:",
  "dashboard.estatísticas": "Statistik",
  "dashboard.uso de equipamento": "Utrustningsanvändning",
  "dashboard.pico de uso": "Toppanvändning",
  "dashboard.receitas mais executadas por equipamento": "Mest förberedda recept per utrustning",
  "dashboard.recolher": "minimera",
  "dashboard.TOROS TC CONECTADOS:": "ANSLUTSLUTNA TOROS TC:",
  "dashboard.Consumo de energia - Lastro Toro TC": "Energiförbrukning - Lastro Toro TC",
  "dashboard.tootilp": "Summan av alla receptförberedelser under den aktuella dagen dividerad med antalet timmar som ugnen är påslagen.",
  "dashboard.noResults": "Inga resultat :(",
  "dashboard.Preaquecimento": "Förvärmning",
  "dashboard.Esfriamento": "Nedkylning",
  "dashboard.Execução de receitas": "Receptförberedelse",
  "dashboard.Execução de receitas TSi": "TSi-receptförberedelse",
  "dashboard.Modo manual": "Manuellt läge",
  "dashboard.Limpeza": "Rengöring",
  "dashboard.Porta": "Dörr",
  "dashboard.Erros e alertas": "Fel och varningar",
  "dashboard.Parâmetros": "Parametrar",
  "dashboard.SEM DADOS POR AQUI": "INGA DATA HÄR",
  "dashboard.AINDA SEM GRÁFICOS POR AQUI": "INGA GRAFER ÄNNU",
  "dashboard.description.AINDA SEM GRÁFICOS POR AQUI": "Välj objekt i listan bredvid för att skapa grafer eller klicka på raden för att se mer information.",

  "//INFORMAÇÕES IOK": "",

  "iokInformation.search.placeholder": "Sök artikel",
  "iokInformation.article.openInHelpCenter": "Visa artikeln i hjälpcentret",
  "iokInformation.aboutPlatform.platformFeatures.title": "Plattformen och dess funktioner",
  "iokInformation.aboutPlatform.platformFeatures.linkLabel": "Ladda ner den fullständiga presentationen",
  "iokInformation.aboutPlatform.manual.title": "Bruksanvisning",
  "iokInformation.aboutPlatform.manual.linkLabel": "Ladda ner manualen",
 "iokInformation.aboutPlatform.privacy.title": "Integritetspolicy",
  "iokInformation.aboutPlatform.privacy.linkLabel": "Ladda ner policyn",
  "iokInformation.aboutPlatform.api.title": "Externt API",
  "iokInformation.aboutPlatform.api.linkLabel": "Ladda ner Dokumentet",

  
  "//Telemetry TSI": "",

  "telemetry.EQUIPMENT_TURN_ON": "Utrustning påslagen",
  "telemetry.SENSORS_VALUES": "Sensorvärden",
  "telemetry.ERROR_DETECTED": "Fel upptäckt",
  "telemetry.TIME_ADDED": "Tid tillagd",
  "telemetry.GN_ADDED": "GN tillagd",
  "telemetry.GN_RELEASED": "GN Startad",
  "telemetry.GN_FINISHED": "GN slutförd",

  "telemetry.HEAVY_CLEANING_CANCELED": "Kraftig rengöring avbruten",
  "telemetry.CLEANING_CANCELED": "Rengöring avbruten",
  "telemetry.CLEANING_RESTARTED": "Rengöring omstartad",
  "telemetry.CLEANING_VAPORIZATION_STEP": "Ångningssteg under rengöring",
  "telemetry.CLEANING_SUPPLY_STEP": "Påfyllningssteg under rengöring",
  "telemetry.CLEANING_CIRCULATION_STEP": "Cirkulationssteg under rengöring",
  "telemetry.CLEANING_DEPLETION_STEP": "Tömningssteg under rengöring",
  "telemetry.CLEANING_RISING_STEP": "Sköljsteg under rengöring",
  "telemetry.CLEANING_STARTED": "Rengöring startad",
  "telemetry.CLEANING_FINISHED": "Rengöring slutförd",
  "telemetry.RECOMMENDED_CLEANING": "Rekommenderad rengöring",
  "telemetry.VALID_PASSWORD_CLEANING": "Giltigt lösenord för rengöring",
  "telemetry.INVALID_PASSWORD_CLEANING": "Ogiltigt lösenord för rengöring",

  "telemetry.RECIPE_STARTED": "Recept startat",
  "telemetry.RECIPE_FINISHED": "Recept slutfört",
  "telemetry.RECIPE_CANCELED": "Recept avbrutet",
  "telemetry.RECIPE_STEP_CHANGED": "Receptsteg ändrat",
  "telemetry.RECIPE_PAUSED": "Recept pausat",
  "telemetry.RECIPE_RESUMED": "Recept återupptaget",
  "telemetry.DROP_ENERGY_SUPPLY": "Återupptagning efter strömavbrott",
  "telemetry.RESUME_RECIPE_CANCELED": "Återupptagning av recept avbruten",

  "telemetry.PRE_HEAT_STARTED": "Förvärmning startad",
  "telemetry.PRE_HEAT_FINISHED": "Förvärmning slutförd",
  "telemetry.OPERATION_CONTINUE_STARTED": "Återupptagning av drift startad",
  "telemetry.OPERATION_CONTINUE_FINISHED": "Återupptagning av drift slutförd",
  "telemetry.HOLD_TEMPERATURE_STARTED": "Temperaturhållning startad",
  "telemetry.HOLD_TEMPERATURE_FINISHED": "Temperaturhållning slutförd",
  "telemetry.COOL_DOWN_STARTED": "Nedkylning Startad",
  "telemetry.COOL_DOWN_FINISHED": "Nedkylning slutförd",
  "telemetry.NOCTURNAL_COOKING_STARTED": "Nattillagning Startad",
  "telemetry.NOCTURNAL_COOKING_FINISHED": "Nattillagning slutförd",
  "telemetry.SEALING_STARTED": "Bryning Startad",
  "telemetry.SEALING_FINISHED": "Bryning slutförd",
  "telemetry.TURBO_GRILL_STARTED": "Turbo Grill startad",
  "telemetry.TURBO_GRILL_FINISHED": "Turbo Grill slutförd",
  "telemetry.TURBO_GRILL_ACTIVATED": "Turbo Grill",
  "telemetry.TURBO_GRILL_DISABLED": "Turbo Grill inaktiverad",

  "telemetry.MOISTURE_CHANGED": "Fuktighet ändrad",
  "telemetry.TURBINE_CHANGED": "Fläktvärde ändrat",
  "telemetry.SET_POINT_CHANGED": "Kammartemperatur ändrad",
  "telemetry.STEAM_CHANGED": "Ånga ändrad",
  "telemetry.PROBE_CHANGED": "Probtemperatur ändrad",
  "telemetry.TIME_CHANGED": "Tid ändrad",
  "telemetry.DOOR_OPENED": "Dörr öppnad",
  "telemetry.DOOR_CLOSED": "Dörr stängd",

  "telemetry.PROBE_CONTROL_SELECTED": "Probstyrning vald",
  "telemetry.TIME_CONTROL_SELECTED": "Tidsstyrning vald",
  "telemetry.MANUAL_STEAM_INJECTED": "Manuell ånginjektion",
  "telemetry.AUTOMATIC_STEAM_INJECTED": "Automatisk ånginjektion",

  "telemetry.DATABASE_CREATED": "Databas skapad",
  "telemetry.EXIT_FUNCTION": "funktion |",
  "telemetry.CONSUMPTION": "Förbrukning",
  "telemetry.STANDBY": "Standby",

  "telemetry.ANALYTICS_ERROR_BAD_REQUEST": "Analyticsfel: Ogiltig begäran",
  "telemetry.ANALYTICS_ERROR_FORBIDDEN": "Analyticsfel: Åtkomst nekad",
  "telemetry.ANALYTICS_ERROR_SERVER": "Analyticsfel: Serverfel",
  "telemetry.ANALYTICS_ERROR_UNEXPECTED": "Analyticsfel: Oväntat fel",
  "telemetry.ANALYTICS_SUCCESS": "Analytics lyckades",

  "telemetry.STEP": "Steg",
  "telemetry.STEAM": "Ånga",
  "telemetry.PROBE": "Prob",
  "telemetry.TURBINE": "Fläkt",
  "telemetry.OCCURRENCES": "förekomst(er)",
  "telemetry.FUNC_USER_RECIPE": "Användarrecept",
  "telemetry.FUNC_TSI_RECIPE": "TSi-recept",
  "telemetry.FUNC_DELTA_T": "Delta T",
  "telemetry.FUNC_STEAM": "Ånga",
  "telemetry.FUNC_COMBINED_STEAM": "Kombinerad ånga",
  "telemetry.FUNC_HOT_AIR": "Varmluft",
  "telemetry.FUNC_NOCTURNAL_COOKING": "Nattillagning",
  "telemetry.FUNC_REGENERATE": "Regenerering",
  "telemetry.FUNC_MULTIPLE_COOKING": "Flerzonsmatlagning",

  "haccp.filterBy": "Filtrera efter",
  "haccp.export.generating": "HACCP-kalkylbladet genereras och kommer snart att laddas ner automatiskt.",
  "haccp.voltage": "Spänning",
  "haccp.voltageReading": "Spänningsavläsning",
  "haccp.voltageOscillation": "Spänningsvariation under dagen",
  "haccp.status.normal": "Normal",
  "haccp.status.attention": "Varning",
  "haccp.status.critical": "Kritisk",
  "haccp.dateTime": "Datum/Tid",
  "haccp.errorDetected": "Fel/Varning upptäckt",
  "haccp.detected": "upptäckt",
  "haccp.errorTypeLabel": "Typ av fel/varning",
  "haccp.severityLabel": "Allvarlighetsgrad",
  "haccp.severity.error": "Fel",
  "haccp.severity.alert": "Varning",
  "haccp.error.canNetwork": "CAN-nätverksfel",
  "haccp.error.chamberSensor": "Kammarsensorfel",
  "haccp.error.steamSensor": "Ångsensorfel",
  "haccp.error.probeSensor": "Probfel",
  "haccp.error.noWater": "Fel: inget vatten",
  "haccp.error.panelTemp": "Paneltemperaturfel",
  "haccp.error.motor": "Motorfel",
  "haccp.error.motorComm": "Motorkommunikationsfel",
  "haccp.error.hygieneIncomplete": "Ofullständig rengöring",
  "haccp.error.familyModel": "Fel på familj/modell",
  "haccp.error.boardTemp": "Korttemperaturfel",
  "haccp.error.energyModule": "Fel på energimodul",
  "haccp.error.i2c": "I2C-fel",
  "haccp.error.gas": "Gasfel",
  "haccp.loading": "Laddar...",
  "haccp.quantity": "Antal",
  "haccp.executions": "Förberedelser",
  "haccp.manual.mode": "Läge",
  "haccp.manual.tempC": "Tempa (°C)",
  "haccp.manual.timeMin": "Tid (min)",
  "haccp.manual.probeC": "Prob (°C)",
  "haccp.manual.steamPct": "Ånga %",
  "haccp.cleaning.label": "Rengöring",
  "haccp.cleaning.recommendedLabel": "Rekommenderad rengöring",
  "haccp.cleaning.status.completed": "Slutförd",
  "haccp.cleaning.status.restarted": "Omstartad",
  "haccp.cleaning.status.interrupted": "Avbruten",
  "haccp.status.label": "Status",
  "haccp.error": "Fel",
  "haccp.consumption.water": "Vattenförbrukning",
  "haccp.consumption.energy": "Energiförbrukning",
  "haccp.short.temp": "Temp",
  "haccp.short.time": "Tid",
  "haccp.day": "Dag Dag Dag Dag Dag",
  "haccp.recipeExecutions": "Antal förberedelser",
  "STEAM": "Ånga",
  "COMBINED_STEAM": "Kombinerad ånga",
  "PROBE": "Prob",
  "TURBINE": "Fläkt",
  "HOT_AIR": "Varmluft",
  "NOCTURNAL_COOKING": "Nattillagning",
  "REGENERATE": "Regenerering",
  "MULTIPLE_COOKING": "Flerzonsmatlagning",
  "DELTA_T": "Delta T",

 
  "//CSAT": "",

  "csat.AVALIE SUA EXPERIÊNCIA": "BEDÖM DIN UPPLEVELSE",
  "csat.Como você avalia sua experiência com": "Hur bedömer du din upplevelse av",
  "csat.Muito insatisfeito": "Mycket missnöjd",
  "csat.Insatisfeito": "Missnöjd",
  "csat.Neutro": "Neutral",
  "csat.Satisfeito": "Nöjd",
  "csat.Muito satisfeito": "Mycket nöjd",
  "csat.Utilize o espaço abaixo para deixar suas sugestões:": "Använd fältet nedan för att lämna dina synpunkter:",
  "csat.Digite aqui": "Skriv här",
  "csat.Obrigado por responder à nossa pesquisa!": "Tack för att du besvarade vår enkät!",
  "csat.Selecione uma nota para continuar": "Välj ett betyg för att fortsätta",
  "csat.Enviar": "Skicka",
  "csat.a criação de receitas": "skapandet av recept",
  "csat.o cadastro de equipamentos": "registreringen av utrustningar",
  "csat.o cadastro de usuários": "registreringen av användare",
  "csat.a criação de menus": "skapandet av menyer",
  "csat.a deleção de receitas": "borttagningen av recept",
  "csat.a reordenação de receitas": "omordningen av recept",
  "csat.o envio de software": "utskick av programvara",
  "csat.o envio de menus": "utskick av menyer",
  "csat.o uso de receitas do Cookbook": "användningen av recept från Cookbook"
 },
};

export default sv;


